import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import { RxCross2 } from "react-icons/rx";
import axios from "axios";
import cheerio from "cheerio";
import { useTranslation } from "react-i18next";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useFormContext } from "../../../context/CreateMeetingContext";
import { getUserRoleID } from "../../Utils/getSessionstorageItems";
import { RiFileExcel2Line, RiFolderVideoLine } from "react-icons/ri";
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import { read, utils } from "xlsx";
import { FaRegFileAudio } from "react-icons/fa";
import { SiGooglemeet } from "react-icons/si";

import {
  DocumentIcon,
  FileFolderIcon,
  VideoIcon,
  CameraIcon,
  LinkIcon,
  ExpandIcon,
} from "../../Utils/MeetingFunctions";
import { CgMail } from "react-icons/cg";
import { formatDate, formatTime } from "../Meeting/GetMeeting/Helpers/functionHelper";

// Function to extract base64 image sources from HTML string
function extractBase64SrcFromHTML(htmlString) {
  const base64SrcArray = [];

  // Load the HTML string into cheerio
  const $ = cheerio.load(htmlString);

  // Find all elements with 'src' attribute
  $("[src]").each((index, element) => {
    const srcValue = $(element).attr("src");

    // Check if the src starts with 'data:image'
    if (srcValue && srcValue?.startsWith("data:image")) {
      // If src is a base64 image, push it into base64SrcArray
      base64SrcArray.push(srcValue);
    }
  });

  return base64SrcArray;
}

// Function to replace base64 image sources with cloud URLs in HTML string
function replaceBase64SrcWithLinks(htmlString, imageLinks) {
  // Load the HTML string into cheerio
  const $ = cheerio.load(htmlString);

  // Find all elements with 'src' attribute
  $("[src]").each((index, element) => {
    const srcValue = $(element).attr("src");

    // Check if the src starts with 'data:image'
    if (srcValue && srcValue?.startsWith("data:image")) {
      // Replace the src with the corresponding link from imageLinks
      $(element).attr("src", imageLinks[index]);
    }
  });

  // Return the modified HTML string
  return $.html();
}

//FrontEnd - Cloudinary
export const optimizeEditorContent = async (editorContent) => {
  if (!editorContent) {
    return "";
    //-------- CLOUD LOGIC ------------------------------
  }
  let optimizedEditorContent = "";
  const base64Array = extractBase64SrcFromHTML(editorContent);
  if (!base64Array.length > 0) {
    optimizedEditorContent = editorContent;
    return optimizedEditorContent;
  } else {
    const cloudinaryUploads = base64Array.map(async (base64Image) => {
      try {
        const response = await fetch(
          "https://api.cloudinary.com/v1_1/drrk2kqvy/upload",
          {
            method: "POST",
            body: JSON.stringify({
              file: base64Image,
              upload_preset: "chat-application",
            }),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        return data.secure_url;
      } catch (error) {
        console.error("Error uploading image to Cloudinary:", error);
        return null;
      }
    });

    const uploadedImageUrls = await Promise.all(cloudinaryUploads);
    const editorContentWithCloudLinks = replaceBase64SrcWithLinks(
      editorContent,
      uploadedImageUrls
    );

    optimizedEditorContent = editorContentWithCloudLinks;
    return optimizedEditorContent;
  }
  // // ------- CLOUD LOGIC END -------------------------
};

//----------------------------------------------

const StepChartAction = ({
  meetingId,
  show,
  closeModal,
  id,
  meeting,
  isDrop,
  setIsDrop,

  closeStep,
  fromTodo,
}) => {
  console.log("meeting", meeting);
  const { checkId, setCall } = useFormContext();
  const userID = parseInt(sessionStorage.getItem("user_id"));
  const SessionUser = JSON.parse(sessionStorage.getItem("user"));
  const TINYMCEAPI = process.env.REACT_APP_TINYMCE_API;
  const location = window.location.href;
  const [isOpen, setIsOpen] = useState(false);
  const [StepPresentor, setStepPresentor] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const fromReport = location.includes("step-details")
    ? true
    : location.includes("meetingDetail")
      ? true
      : false;
  const [t] = useTranslation("global");
  const options = [
    { value: "Editeur", label: t("stepModal.editor"), icon: <DocumentIcon /> },
    { value: "File", label: t("stepModal.pdf"), icon: <FileFolderIcon /> },
    { value: "Video", label: t("stepModal.video"), icon: <VideoIcon /> },
    { value: "Photo", label: t("stepModal.photo"), icon: <CameraIcon /> },
    { value: "Url", label: t("stepModal.url"), icon: <LinkIcon /> },
    {
      value: "Excel",
      label: t("stepModal.excel"),
      icon: <RiFileExcel2Line className="fs-5" />,
    },
     {
          value: "Google Meet Link",
          label: t("stepModal.googleMeetLink"),
          icon: <SiGooglemeet className="fs-5" />,
        },
  ];
  const SpecialMeetingOptions = [
    {
      value: "Audio Report",
      label: t("stepModal.audioReport"),
      icon: <FaRegFileAudio className="fs-5" />,
    },
    {
      value: "Video Report",
      label: t("stepModal.videoReport"),
      icon: <RiFolderVideoLine className="fs-5" />,
    },
  ];
  const newsletterOption = [
    { value: "Email", label: t("stepModal.email"), icon: <CgMail /> },
  ];
  const taskOption = [
    { value: "Subtask", label: t("stepModal.subtask"), icon: <DocumentIcon /> },
  ];

  const LawOption = [
    {
      value: "Question",
      label: t("stepModal.laweditor"),
      icon: <DocumentIcon />,
    },
  ];

    const AbsenceOption = [
      {
        value: "Absence CET non payable",
        label: t("meeting.absence_step_type.absence_type_1"),
        icon: <DocumentIcon />,
      },
      {
        value: "Absence CET payable",
        label: t("meeting.absence_step_type.absence_type_2"),
        icon: <DocumentIcon />,
      },
      {
        value: "Partial unemployment",
        label: t("meeting.absence_step_type.absence_type_3"),
        icon: <DocumentIcon />,
      },
      {
        value: "Paid leave",
        label: t("meeting.absence_step_type.absence_type_4"),
        icon: <DocumentIcon />,
      },
      // {
      //   value: "Corporate event",
      //   label: t("meeting.absence_step_type.absence_type_5"),
      //   icon: <DocumentIcon />,
      // },
      // {
      //   value: "Skills sponsorship",
      //   label: t("meeting.absence_step_type.absence_type_6"),
      //   icon: <DocumentIcon />,
      // },
      {
        value: "Recovery",
        label: t("meeting.absence_step_type.absence_type_7"),
        icon: <DocumentIcon />,
      },
      {
        value: "RTT",
        label: t("meeting.absence_step_type.absence_type_8"),
        icon: <DocumentIcon />,
      },
    ];
  const handleSelect = (option) => {
    setModalType(option.value);
    setIsOpen(false);
    setFileName("");
    setExcelData(null);
  };

  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedCount, setSelectedCount] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(1);

  const [orderNo, setOrderNo] = useState(null);
  const [storedStartTime, setStoredStartTime] = useState(null);
  const [storedStartDate, setStoredStartDate] = useState(null);
  const [storedStartDateForHour, setStoredStartDateForHour] = useState(null);
  const [modifiedFileText, setModifiedFileText] = useState();
  const [modalType, setModalType] = useState("");
  const [assignUser, setAssignUser] = useState(null);
  const [assignTeam, setAssignTeam] = useState(null);
  const [stepOrder, setStepOrder] = useState(null);
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isValidate, setIsValidate] = useState(false);

  const [fileName, setFileName] = useState("");
  const [isUpload, setIsUpload] = useState(false);

  const [link, setLink] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");

  const [createAnother, setCreateAnother] = useState(false);
  const handleCheckboxChange = (e) => {
    setCreateAnother(e.target.checked);
  };

  const optimizeEditorContent = async (editorContent) => {
    if (!editorContent) {
      return "";
      //-------- CLOUD LOGIC ------------------------------
    }
    let optimizedEditorContent = "";
    setIsValidate(true);
    const base64Array = extractBase64SrcFromHTML(editorContent);
    if (!base64Array.length > 0) {
      optimizedEditorContent = editorContent;
      return optimizedEditorContent;
    } else {
      const cloudinaryUploads = base64Array.map(async (base64Image) => {
        try {
          const response = await fetch(
            "https://api.cloudinary.com/v1_1/drrk2kqvy/upload",
            {
              method: "POST",
              body: JSON.stringify({
                file: base64Image,
                upload_preset: "chat-application",
              }),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();

          return data.secure_url;
        } catch (error) {
          console.error("Error uploading image to Cloudinary:", error);
          return null;
        }
      });

      const uploadedImageUrls = await Promise.all(cloudinaryUploads);
      const editorContentWithCloudLinks = replaceBase64SrcWithLinks(
        editorContent,
        uploadedImageUrls
      );
      setIsValidate(false);

      optimizedEditorContent = editorContentWithCloudLinks;
      return optimizedEditorContent;
    }

    // // ------- CLOUD LOGIC END -------------------------
  };

  const [participantLabels, setParticipantLabels] = useState([]);
  console.log('participantLabels', participantLabels)

  useEffect(() => {
    const fetchParticipantLabel = async () => {
      if (!show || !meeting?.id || !storedStartDate || !storedStartTime) return;
      // Convert "01/07/2025" → "2025-07-01"
      const formattedDate = moment(storedStartDate, "DD/MM/YYYY").format("YYYY-MM-DD");

      // Convert "07h36" → "07:36:00"
      const formattedTime = storedStartTime?.replace("h", ":") + ":00";

      try {
        const payload = {
          meeting_id: meeting.id,
          date: formattedDate,      // e.g., "2025-06-24"
          time: formattedTime,       // e.g., "02:10:00 PM"
          count2: selectedCount,
          time_unit:
            meeting?.type === "Action1" ||
              meeting?.type === "Newsletter" ||
              meeting?.type === "Strategy" || meeting?.type === "Absence"
              ? "days"
              : meeting?.type === "Task"
                ? "hours"
                : meeting?.type === "Quiz"
                  ? "seconds"
                  : "minutes",
        };

        const response = await axios.post(`${API_BASE_URL}/get-participant-label`,
          payload
        );

        console.log("API response:", response.data);
        setParticipantLabels(response.data.participant || []);
        // handle response here
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchParticipantLabel();
  }, [show, meeting, meeting?.id, storedStartTime, selectedCount]);
  const getLabelForParticipant = (email) => {
    const match = participantLabels.find((p) => p.email === email)?.label || null;
    console.log("Matched participant:", match);
    return match
  };

  const getStatusLabel = (status) => {
    let color = "";
    let bg = "";
    switch (status) {
      case "Disponible":
        color = "#2e7d32";
        bg = "#e8f5e9";
        break;
      case "Occupied":
        color = "#ef6c00";
        bg = "#fff3e0";
        break;
      case "Absent":
        color = "#c62828";
        bg = "#ffebee";
        break;
      default:
        color = "#757575";
        bg = "#eeeeee";
    }

    return (
      <span
        style={{
          marginLeft: "10px",
          fontSize: "0.75rem",
          fontWeight: 600,
          padding: "3px 8px",
          borderRadius: "12px",
          color: color,
          backgroundColor: bg,
        }}
      >
        {status}
      </span>
    );
  };

  // Set modalType based on inputData once it is available
  useEffect(() => {
    if (meeting?.type) {
      setModalType(
        meeting?.type === "Law" ? "Question"
          : meeting?.type === "Newsletter" ? "Email"
            : meeting?.type === "Task" ? "Subtask"
              : meeting?.type === "Special" ? "Audio Report"
                : meeting?.type === "Google Agenda Event" ? "Google Meet Link"
                  : meeting?.type === "Absence" ? "Absence CET non payable"
                    : modalType ? modalType
                      : "Editeur"
      );
    }
  }, [meeting?.type, show]);
  const [fileUploaded, setFileUploaded] = useState(false);

  const [disabled, setDisabled] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileDuration, setFileDuration] = useState(null);
  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setSelectedFile(file);
    setIsUpload(true);
    let allowedFileTypes = [];

    // Determine allowed file types based on modalType
    if (modalType === "File") {
      allowedFileTypes = [
        "application/pdf",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
    } else if (modalType === "Video") {
      allowedFileTypes = [
        "video/mp4",
        "video/x-msvideo",
        "video/x-matroska",
        "video/mpeg",
        "video/quicktime",
      ];
    } else if (modalType === "Photo") {
      allowedFileTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/bmp",
        "image/webp",
        // Add other image MIME types if needed
      ];
    } else if (modalType === "Excel") {
      allowedFileTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
    } else if (modalType === "Video Report") {
      allowedFileTypes = [
        "video/mp4",
        "video/x-msvideo",
        "video/x-matroska",
        "video/mpeg",
        "video/quicktime",
      ];
    } else if (modalType === "Audio Report") {
      allowedFileTypes = [
        "audio/mpeg",
        "audio/wav",
        "audio/webm",
        "audio/ogg",
        "audio/x-ms-wma",
        "audio/aac",
      ];
    }

    // Check file size (10 MB = 10 * 1024 * 1024 bytes)
    if (file.size > 10 * 1024 * 1024) {
      toast.error(t("meeting.chart.error.file"));
      setIsUpload(false);
      return;
    }
    if (file && allowedFileTypes.includes(file.type)) {
      if (file && modalType === "Excel") {
        let reader = new FileReader();

        // Wait for the file to be loaded before processing it
        reader.onload = (e) => {
          const fileData = new Uint8Array(e.target.result);
          const workbook = XLSX.read(fileData, { type: "array" });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          const formattedData = data.map((row, rowIndex) =>
            row.map((cell, cellIndex) => ({
              value: cell,
              readOnly: rowIndex === 0,
            }))
          );
          setExcelData(formattedData);
        };

        reader.readAsArrayBuffer(file); // Trigger file reading
      }

      if (id === null) {
        setDisabled(true);
        try {
          const assignedToUser =
            user?.id ||
            (meeting?.user_with_participants || meeting?.participants || [])?.find(
              (participant) => participant.email === meeting?.user?.email
            )?.id;

          const filePayload = {
            title: selectedValue || "",
            count1: selectedCount || 0,
            count2: selectedCount || 0,
            time_unit:
              meeting?.type === "Action1" ||
                meeting?.type === "Newsletter" ||
                meeting?.type === "Strategy"
                ? "days"
                : meeting?.type === "Task"
                  ? "hours"
                  : meeting?.type === "Quiz"
                    ? "seconds"
                    : "minutes",
            time: selectedCount,
            editor_type:
              modalType === "File"
                ? "File"
                : modalType === "Video"
                  ? "Video"
                  : modalType === "Photo"
                    ? "Photo"
                    : modalType,
            file: file,
            editor_content: null,
            meeting_id: meetingId,
            assigned_to: assignedToUser,
            // assigned_to_team: meeting?.type === "Newsletter" ? team : null,
            assigned_to_team: meeting?.type === "Newsletter" ? null : null,
            status: "active",
            url: null,
            created_by: userID,
            // _method: "put",
          };

          const formData = new FormData();
          formData.append("title", filePayload.title);
          formData.append("count1", filePayload.count1);
          formData.append("count2", filePayload.count2);
          formData.append("time", filePayload.time);
          formData.append("editor_type", filePayload.editor_type);
          formData.append("time_unit", filePayload.time_unit);
          formData.append("file", filePayload.file);
          formData.append("editor_content", filePayload.editor_content);
          formData.append("meeting_id", filePayload.meeting_id);
          formData.append("status", filePayload.status);
          formData.append("assigned_to", filePayload.assigned_to);
          formData.append("assigned_to_team", filePayload.assigned_to_team);
          formData.append("created_by", filePayload.created_by);
          formData.append("url", filePayload.url);
          // formData.append("_method", filePayload._method);

          const response = await axios.post(`${API_BASE_URL}/steps`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });

          if (response.status === 200) {
            setFileName(response.data?.data?.file);
            setIsUpload(false);
            // setId(response?.data?.data?.id);
            setIsUpdate(false);
            setIsDrop(true);
            setDisabled(false);

            setFileUploaded(true); // Add this line
          }
        } catch (error) {
          setIsUpload(false);
          setDisabled(false);
        }
      } else {
        try {
          setDisabled(false);

          const assignedToUser =
            user?.id ||
            (meeting?.user_with_participants || meeting?.participants || [])?.find(
              (participant) => participant.email === meeting?.user?.email
            )?.id;
          const filePayload = {
            title: selectedValue,
            count1: selectedCount || 0,
            count2: selectedCount || 0,
            order_no: selectedOrder || 1,

            time_unit:
              meeting?.type === "Action1" ||
                meeting?.type === "Newsletter" ||
                meeting?.type === "Strategy"
                ? "days"
                : meeting?.type === "Task"
                  ? "hours"
                  : meeting?.type === "Quiz"
                    ? "seconds"
                    : "minutes",
            time: selectedCount || 0,
            editor_type:
              modalType === "File"
                ? "File"
                : modalType === "Video"
                  ? "Video"
                  : modalType === "Photo"
                    ? "Photo"
                    : modalType,
            file: file,
            editor_content: null,
            meeting_id: meetingId,
            assigned_to: assignedToUser,
            // assigned_to_team: meeting?.type === "Newsletter" ? team : null,
            assigned_to_team: meeting?.type === "Newsletter" ? null : null,
            status: "active",
            url: null,
            _method: "put",
          };

          const formData = new FormData();
          formData.append("title", filePayload.title);
          formData.append("count1", filePayload.count1);
          formData.append("count2", filePayload.count2);
          formData.append("time", filePayload.time);
          formData.append("editor_type", filePayload.editor_type);
          formData.append("time_unit", filePayload.time_unit);
          formData.append("file", filePayload.file);
          formData.append("editor_content", filePayload.editor_content);
          formData.append("meeting_id", filePayload.meeting_id);
          formData.append("status", filePayload.status);
          formData.append("assigned_to", filePayload.assigned_to);
          formData.append("assigned_to_team", filePayload.assigned_to_team);

          formData.append("url", filePayload.url);
          formData.append("_method", filePayload._method);

          const response = await axios.post(
            `${API_BASE_URL}/steps/${id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );

          if (response.status === 200) {
            setFileName(response.data?.data?.file);
            setIsUpload(false);
            // setId(response?.data?.data?.id);
            setIsDrop(false);

            // setIsUpdate(false);
          }
        } catch (error) {
          console.log("error while uploading file", error);
          setIsUpload(false);
        }
      }
    } else {
      alert(
        `Please select a valid file type for ${modalType}: ${allowedFileTypes.join(
          ", "
        )}`
      );

      setIsUpload(false);
    }
  };
  const handleMediaDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setSelectedFile(file);
    setIsUpload(true);
    let allowedFileTypes = [];

    // Determine allowed file types based on modalType
    if (modalType === "Video Report") {
      allowedFileTypes = [
        "video/mp4",
        "video/x-msvideo",
        "video/x-matroska",
        "video/mpeg",
        "video/quicktime",
      ];
    } else if (modalType === "Audio Report") {
      allowedFileTypes = [
        "audio/mpeg",
        "audio/wav",
        "audio/webm",
        "audio/ogg",
        "audio/x-ms-wma",
        "audio/aac",
      ];
    }

    // Check if the file type is allowed
    if (!allowedFileTypes.includes(file?.type)) {
      toast.error(t("meeting.chart.error.invalidFileType"));
      setIsUpload(false);
      return;
    }
    // Check file size (6 MB = 6 * 1024 * 1024 bytes)
    if (file.size > 10 * 1024 * 1024) {
      // toast.error(t("meeting.chart.error.file"));
      toast.error(t("meeting.chart.error.file"));
      setIsUpload(false);
      return;
    }
    if (file && allowedFileTypes.includes(file.type)) {
      let count2;
      let timeUnit;
      // If the file is an audio or video file, retrieve its duration
      if (modalType === "Video Report" || modalType === "Audio Report") {
        const mediaElement = document.createElement(
          modalType === "Audio Report" ? "audio" : "video"
        );
        mediaElement.src = URL.createObjectURL(file);

        mediaElement.onloadedmetadata = async () => {
          const durationInSeconds = mediaElement.duration; // Duration in seconds
          let formattedDuration;

          if (durationInSeconds < 60) {
            formattedDuration = `${Math.round(durationInSeconds)} secs`; // Show seconds only
            count2 = Math.round(durationInSeconds); // Set count2 to total seconds
            setSelectedCount(count2);
            timeUnit = "seconds"; // Set time unit to 'sec'
          } else if (durationInSeconds < 3600) {
            // Less than 60 minutes
            const totalMinutes = Math.floor(durationInSeconds / 60); // Use floor to get full minutes
            const remainingSeconds = durationInSeconds % 60;

            if (remainingSeconds === 0) {
              // No rounding needed if it's exactly N minutes
              formattedDuration = `${totalMinutes} mins`;
              count2 = totalMinutes; // Set count2 to total minutes
            } else {
              // Round up if there are remaining seconds
              const roundedMinutes = Math.ceil(durationInSeconds / 60);
              formattedDuration = `${roundedMinutes} mins`;
              count2 = roundedMinutes; // Set count2 to rounded minutes
            }

            setSelectedCount(count2);
            timeUnit = "minutes"; // Set time unit to 'min'
          } else {
            // 60 minutes or more
            const totalHours = Math.floor(durationInSeconds / 3600);
            const remainingMinutes = Math.ceil((durationInSeconds % 3600) / 60);
            formattedDuration = `${totalHours} hour${totalHours > 1 ? "s" : ""
              } ${remainingMinutes > 0 ? `${remainingMinutes} mins` : ""}`.trim(); // Show hours and minutes
            count2 = totalHours; // Set count2 to total hours
            setSelectedCount(count2);
            timeUnit = "hours"; // Set time unit to 'hour'
          }

          setFileDuration(formattedDuration); // Store the formatted duration in state

          if (id === null) {
            setDisabled(true);
            try {
              const assignedToUser =
                user?.id ||
                (meeting?.user_with_participants || meeting?.participants || [])?.find(
                  (participant) => participant.email === meeting?.user?.email
                )?.id;
              const currentTime = new Date();

              // User's time zone
              const userTimeZone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              // Format dates and times
              const formattedEndDate = currentTime.toLocaleDateString("en-GB", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                timeZone: userTimeZone,
              });
              const filePayload = {
                title: selectedValue || "",
                count1: count2 || 0,
                count2: count2 || 0,
                time_unit:
                  meeting?.type === "Action1" ||
                    meeting?.type === "Newsletter" ||
                    meeting?.type === "Strategy"
                    ? "days"
                    : meeting?.type === "Task"
                      ? "hours"
                      : meeting?.type === "Quiz"
                        ? "seconds"
                        : meeting?.type === "Special"
                          ? timeUnit
                          : "minutes",
                time: count2,
                editor_type:
                  modalType === "File"
                    ? "File"
                    : modalType === "Video"
                      ? "Video"
                      : modalType === "Photo"
                        ? "Photo"
                        : modalType,
                file: file,
                editor_content: null,
                meeting_id: meetingId,
                assigned_to: assignedToUser,
                // assigned_to_team: meeting?.type === "Newsletter" ? team : null,
                assigned_to_team: meeting?.type === "Newsletter" ? null : null,
                status: "active",
                url: null,
                created_by: userID,
                step_status: meeting?.type === "Special" ? "completed" : null,
                end_date: meeting?.type === "Special" ? formattedEndDate : null,
                // _method: "put",
              };

              const formData = new FormData();
              formData.append("title", filePayload.title);
              formData.append("count1", filePayload.count1);
              formData.append("count2", filePayload.count2);
              formData.append("time", filePayload.time);
              formData.append("editor_type", filePayload.editor_type);
              formData.append("time_unit", filePayload.time_unit);
              formData.append("file", filePayload.file);
              formData.append("editor_content", filePayload.editor_content);
              formData.append("meeting_id", filePayload.meeting_id);
              formData.append("status", filePayload.status);
              formData.append("step_status", filePayload.step_status);
              formData.append("end_date", filePayload.end_date);
              formData.append("assigned_to", filePayload.assigned_to);
              formData.append("assigned_to_team", filePayload.assigned_to_team);
              formData.append("created_by", filePayload.created_by);
              formData.append("url", filePayload.url);
              // formData.append("_method", filePayload._method);

              const response = await axios.post(
                `${API_BASE_URL}/steps`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  },
                }
              );

              if (response.status === 200) {
                setFileName(response.data?.data?.file);
                setTimeUnit(response?.data?.data?.time_unit);
                setIsUpload(false);
                // setId(response?.data?.data?.id);
                setIsUpdate(false);
                setIsDrop(true);
                setDisabled(false);

                setFileUploaded(true); // Add this line
              }
            } catch (error) {
              console.log("error while uploading file", error);
              setIsUpload(false);
              setDisabled(false);
            }
          } else {
            try {
              setDisabled(false);

              const assignedToUser =
                user?.id ||
               (meeting?.user_with_participants || meeting?.participants || [])?.find(
                  (participant) => participant.email === meeting?.user?.email
                )?.id;
              const filePayload = {
                title: selectedValue,
                count1: count2 || 0,
                count2: count2 || 0,
                time_unit:
                  meeting?.type === "Action1" ||
                    meeting?.type === "Newsletter" ||
                    meeting?.type === "Strategy"
                    ? "days"
                    : meeting?.type === "Task"
                      ? "hours"
                      : meeting?.type === "Quiz"
                        ? "seconds"
                        : meeting?.type === "Special"
                          ? timeUnit
                          : "minutes",
                time: count2,
                editor_type:
                  modalType === "File"
                    ? "File"
                    : modalType === "Video"
                      ? "Video"
                      : modalType === "Photo"
                        ? "Photo"
                        : modalType,
                file: file,
                editor_content: null,
                meeting_id: meetingId,
                assigned_to: assignedToUser,
                // assigned_to_team: meeting?.type === "Newsletter" ? team : null,
                assigned_to_team: meeting?.type === "Newsletter" ? null : null,
                status: "active",
                url: null,
                _method: "put",
              };

              const formData = new FormData();
              formData.append("title", filePayload.title);
              formData.append("count1", filePayload.count1);
              formData.append("count2", filePayload.count2);
              formData.append("time", filePayload.time);
              formData.append("editor_type", filePayload.editor_type);
              formData.append("time_unit", filePayload.time_unit);
              formData.append("file", filePayload.file);
              formData.append("editor_content", filePayload.editor_content);
              formData.append("meeting_id", filePayload.meeting_id);
              formData.append("status", filePayload.status);
              formData.append("assigned_to", filePayload.assigned_to);
              formData.append("assigned_to_team", filePayload.assigned_to_team);

              formData.append("url", filePayload.url);
              formData.append("_method", filePayload._method);

              const response = await axios.post(
                `${API_BASE_URL}/steps/${id}`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  },
                }
              );

              if (response.status === 200) {
                setFileName(response.data?.data?.file);
                setTimeUnit(response?.data?.data?.time_unit);
                setIsUpload(false);
                // setId(response?.data?.data?.id);
                setIsDrop(false);

                // setIsUpdate(false);
              }
            } catch (error) {
              console.log("error while uploading file", error);
              setIsUpload(false);
            }
          }
        };

        mediaElement.onerror = () => {
          console.error("Unable to load media file for duration calculation.");
        };
      }
    } else {
      alert(
        `Please select a valid file type for ${modalType}: ${allowedFileTypes.join(
          ", "
        )}`
      );

      setIsUpload(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept:
      modalType === "Video" || modalType === "Video Report"
        ? { "video/*": [] } // Accept all video types
        : modalType === "Photo"
          ? { "image/*": [] } // Accept all image types
          : modalType === "File"
            ? { "application/pdf": [] } // Accept PDF files
            : modalType === "Excel"
              ? {
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                  [],
                "application/vnd.ms-excel": [],
              }
              : modalType === "Audio Report"
                ? { "audio/*": [] }
                : "",
    onDrop:
      modalType === "Video Report" || modalType === "Audio Report"
        ? handleMediaDrop
        : onDrop,
  });

  const [user, setUser] = useState(null);

  const handleUserSelect = (item) => {
    setUser(item);
    setStepPresentor(!StepPresentor);
    // const selectedId = Number(e.target.value);
    // // setSelectedUser(selectedId);
  };
  const [team, setTeam] = useState(null);
  const handleTeamSelect = (item) => {
    // setTeam(e.target.value);
    // const selectedId = Number(e.target.value);
    setTeam(item);
    setStepPresentor(!StepPresentor);
  };

  const [creator, setCreator] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setCreator(JSON.parse(storedUser));
      // setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleChange1 = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleIncrementCount = () => {
    setSelectedCount((prevCount) => prevCount + 1);
  };
  const handleDecrementCount = () => {
    setSelectedCount((prevCount) => (prevCount > 0 ? prevCount - 1 : 0));
  };

  const deleteStepX = async () => {
    setIsUpdate(false);
    setCreateAnother(false);
    setFileUploaded(false);
    // setId(null);
    setSelectedValue("");
    setSelectedOrder(1);
    setOrderNo(null);
    setUser("");
    setTeam("");
    setModifiedFileText("");
    setSelectedCount(0);
    closeModal();
    setIsValidate(false);
    setModalType("");
    setLink("");
  };

  const handleSpreadsheetChange = (newData) => {
    setExcelData(newData);
  };

  const updateExcelFile = async () => {
    try {
      setIsValidate(true);
      // Add Excel file in its original format
      // Convert JSON to a 2D array
      const sheetData = excelData.map((row) =>
        row.map((cell) => cell?.value || "")
      );
      // Create a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Write workbook to binary string
      const workbookBinary = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "binary",
      });

      // Convert binary string to Blob
      const excelBlob = new Blob(
        [
          new Uint8Array(
            workbookBinary.split("").map((char) => char.charCodeAt(0))
          ),
        ],
        {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
      );

      // Create FormData
      const formData = new FormData();
      formData.append("file", new File([excelBlob], "updated_data.xlsx"));
      formData.append("step_id", id);

      const response = await axios.post(
        `${API_BASE_URL}/update-excel-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status) {
        setIsValidate(false);
        return response.data.step;
      }
    } catch (error) {
      console.log("error while update excel file", error);
      setIsValidate(false);
    }
  };
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [finalizing, setFinalizing] = useState(false); // Track processing after upload

  const uploadAudioReport = async () => {
    try {
      setIsValidate(true);
      // Add Excel file in its original format
      setIsProcessing(true);
      setFinalizing(false);

      // Create FormData
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("step_id", id);
      setUploadProgress(0); // Reset progress at the start
      const response = await axios.post(
        `${API_BASE_URL}/speech-to-text`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // Cap progress to 95% during upload
            setUploadProgress(Math.min(percentCompleted, 95));
          },
        }
      );
      if (response?.status) {
        setSelectedFile(null);
        setFinalizing(true);
        setIsValidate(false);
        setUploadProgress(100); // Ensure progress reaches 100% only after server responds
        setTimeout(() => {
          setUploadProgress(0); // Reset progress bar after a short delay
        }, 1000);
        // return response.data.step;
      }
    } catch (error) {
      console.log("error while update excel file", error);
      setIsValidate(false);
      setUploadProgress(0);
    } finally {
      setIsProcessing(false);
      setFinalizing(false);
      setSelectedFile(null);
      // setUploadProgress(100); // Ensure progress reaches 100% only after server responds
    }
  };

  
    const staticContents = {
    "Absence CET non payable": `Une absence CET non payable signifie que le salarié utilise du temps stocké sur son Compte Épargne Temps pour s’absenter, sans contrepartie financière immédiate.
  
  📌 Concrètement, cela implique :
  Le salarié pose un jour (ou une demi-journée) via le CET.
  
  Ce jour est déduit du solde en temps du CET.
  
  Il n’est pas rémunéré en plus : l’absence ne génère pas de paiement (ni sur le bulletin de paie, ni en prime, ni en indemnité).
  
  Elle n’impacte pas le salaire mensuel, car c’est du temps "prépayé" par les jours précédemment épargnés.`,
  
    "Absence CET payable": `Une absence CET payable correspond à une journée ou période d’absence prise au titre du Compte Épargne Temps (CET), et qui donne lieu à un versement monétaire au salarié.
  Autrement dit, le salarié monétise un ou plusieurs jours de CET pour les transformer en rémunération.
  
  📌 Concrètement, cela implique :
  Le salarié utilise un jour (ou plus) stocké sur son CET.
  
  Le jour n’est pas pris en congé effectif (ou peut l’être dans certains cas).
  
  Il est converti en argent, selon la valeur du jour (souvent basée sur le salaire journalier brut).
  
  Ce montant apparaît sur la fiche de paie, généralement sous une ligne du type : Indemnité CET, Monétisation CET, ou CET payable.`,
  
    "Partial unemployment": `Le chômage partiel est un dispositif permettant à une entreprise de réduire temporairement le temps de travail de ses salariés (voire de suspendre leur activité) en cas de difficultés économiques ou conjoncturelles, tout en évitant des licenciements.
  
  Pendant cette période, les salariés ne travaillent pas ou travaillent moins, et reçoivent une indemnité compensatoire financée partiellement ou totalement par l’État.
  
  👷‍♂ Pour le salarié
  Il ne travaille pas pendant tout ou partie de ses heures habituelles.
  
  Il reçoit une indemnité versée par l’employeur, égale à 60 % de son salaire brut (soit environ 72 % du net).
  
  Dans certains cas, des compléments peuvent être versés par l’entreprise pour maintenir le revenu.
  
  🔁 Cette indemnité remplace le salaire habituel sur les heures non travaillées`,
  
    "Paid leave": `Les congés payés sont des jours de repos légaux rémunérés, accordés à un salarié pour compenser son temps de travail.
  Ils permettent de prendre du repos tout en continuant à percevoir sa rémunération habituelle.
  
  📌 Principe général
  Acquisition : le salarié acquiert 2,5 jours ouvrables de congés payés par mois travaillé (soit 30 jours ouvrables ou 5 semaines pour une année complète).
  
  Période de référence : généralement du 1er juin au 31 mai de l’année suivante, sauf accord d’entreprise.`,
  
    "Recovery": `Une absence pour récupération (souvent appelée « récupération d'heures supplémentaires » ou « récupération du temps de travail ») est une période de repos accordée à un salarié en contrepartie d'un temps de travail effectué au-delà de l'horaire normal, sans paiement en heures supplémentaires.
  
  Autrement dit : le salarié ne travaille pas, mais ce temps d'absence est justifié et payé car il compense du temps déjà travaillé.
  
  🧩 Contexte d'application
  Elle peut intervenir :
  
  Après des heures supplémentaires non majorées compensées en temps
  
  Après un travail exceptionnel un jour de repos (ex. salon, intervention le samedi)
  
  Dans le cadre d'un accord d'entreprise ou d'une convention collective
  
  📌 Caractéristiques
  L'absence est justifiée, autorisée et planifiée.
  
  Elle n'impacte pas le salaire (temps déjà "payé" par avance).
  
  Elle doit être prise dans un délai précis après les heures effectuées (souvent sous 8 semaines).
  
  Elle peut apparaître sur le planning ou les outils RH comme :
  Absence – Récupération, Repos compensateur, Jour de récupération`,
  
    "RTT": `Le RTT, ou Réduction du Temps de Travail, est un dispositif qui permet aux salariés de bénéficier de jours de repos supplémentaires lorsque leur temps de travail dépasse la durée légale de 35 heures par semaine, sans que cela soit considéré comme des heures supplémentaires.
  
  🧩 Contexte
  Le RTT concerne principalement :
  
  Les cadres au forfait jours
  
  Les salariés travaillant plus de 35 heures par semaine dans le cadre d'un accord collectif
  
  Les entreprises ayant adopté la réduction du temps de travail tout en maintenant une durée de travail hebdomadaire au-dessus de la norme
  
  📌 Fonctionnement
  Les heures travaillées au-delà de 35 h, mais dans le cadre prévu, ne sont pas rémunérées en heures supplémentaires, mais compensées par du temps de repos.
  
  Le nombre de jours RTT varie selon l'organisation du travail et les accords collectifs (souvent 10 à 12 jours par an).
  
  Ces jours peuvent être posés par le salarié, ou dans certains cas, imposés par l'employeur (RTT collectif).`,
  
    "Corporate event": "Contenu statique pour Corporate event",
    "Skills sponsorship": "Contenu statique pour Skills sponsorship"
  };
  const validateStep = async () => {
    // Update Excel file and get the updated file path
    let updatedExcelFileUrl = null;
    let updatedAudioReport = null;
    if (modalType === "Excel") {
      try {
        updatedExcelFileUrl = await updateExcelFile();
      } catch (error) {
        setIsValidate(false);
        return;
      }
    } else if (modalType === "Audio Report" || modalType === "Video Report") {
      try {
        updatedAudioReport = await uploadAudioReport();
      } catch (error) {
        setIsValidate(false);
        return;
      }
    }
    //  else if (inputData.type = "Law") {

    // }
    if (id) {
      const optimizedEditorContent = await optimizeEditorContent(
        modifiedFileText
      );
      const Steps = [...(meeting?.steps || [])];

      if (!selectedValue?.trim()) {
        toast.error(t("messages.stepTitle"));
        setIsValidate(false);
        return;
      }

      // if (!isUnique) {
      //   toast.error(t("messages.stepNames"));
      //   setIsValidate(false);
      //   return;
      // }

      if (selectedCount === 0) {
        toast.error(t("messages.stepTime"));
        setIsValidate(false);
        return;
      }

      const assignedToUser =
        user?.id ||
        (meeting?.user_with_participants || meeting?.participants || [])?.find(
          // (participant) => participant.email === meeting?.user?.email
          (participant) => participant.email === creator?.email
        )?.id;

      const assignedToYou = (meeting?.user_with_participants || meeting?.participants || [])?.find(
        (participant) => participant.email === SessionUser?.email
      )?.id;

      const currentTime = new Date();

      // User's time zone
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Format dates and times
      const formattedEndDate = currentTime.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        timeZone: userTimeZone,
      });
      const localCurrentTime = currentTime.toLocaleString("en-GB", {
        timeZone: userTimeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      const formattedCurrentDate = currentTime.toISOString().split("T")[0];

      // Format date and time in user's timezone
      const stepTimeFormatted = moment().tz(userTimeZone).format("hh:mm:ss A"); // "05:27:40 PM"
      const startDateFormatted = moment().tz(userTimeZone).format("YYYY-MM-DD"); // "2025-04-30"
      const existingInProgressStepForAssignee = meeting?.steps?.find(
        (step) =>
          step.step_status === "in_progress" &&
          step.assigned_to === assignedToUser && // New assignee should not already have an in-progress step
          step.step_id !== id // Exclude the current step being reassigned
      );

      const stepStatus =
        meeting?.type === "Task" || meeting?.type === "Strategy"
          ? (existingInProgressStepForAssignee ? "todo" : "in_progress")
          : "in_progress";

      const payload = {
        title: selectedValue,
        count1: selectedCount,
        count2: selectedCount,
        order_no: selectedOrder || 1,
        time_unit:
          meeting?.type === "Action1" ||
            meeting?.type === "Newsletter" ||
            meeting?.type === "Strategy" || meeting?.type === "Absence"
            ? "days"
            : meeting?.type === "Task"
              ? "hours"
              : meeting?.type === "Quiz"
                ? "seconds"
                : meeting?.type === "Special"
                  ? timeUnit
                  : "minutes",
        time: selectedCount,
        editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
        editor_content:
          modalType === "Editeur" ||
            modalType === "Subtask" ||
            modalType === "Question" ||
            modalType === "Email" 
            ? optimizedEditorContent || ""
            : [
              "Absence CET non payable",
              "Absence CET payable",
              "Partial unemployment",
              "Paid leave",
              "Corporate event",
              "Skills sponsorship",
              "Recovery",
              "RTT"
            ].includes(modalType)
              ? staticContents[modalType] // Include the static content
              : null,
        file:
          modalType === "File"
            ? fileName
              ? fileName
              : null
            : modalType === "Excel"
              ? updatedExcelFileUrl || fileName
              : fileName,
        assigned_to:
          meeting?.type === "Newsletter"
            ? null
            : fromTodo
              ? assignedToYou
              : assignedToUser,
        assigned_to_team:
          meeting?.type === "Newsletter"
            ? null
            : null,
        status: stepStatus,
        step_status: stepStatus, // <-- Updated based on the condition
        current_time: localCurrentTime,
        current_date: formattedCurrentDate,
        url:
          modalType === "Url" || modalType === "Google Meet Link"
            ? link
              ? link
              : null
            : null,
        meeting_id: meetingId,
        created_by: userID,
        end_date: meeting?.type === "Special" ? formattedEndDate : null,
        step_time: stepTimeFormatted,
        start_date: startDateFormatted
      };

      // const payload = {
      //   title: selectedValue,
      //   count1: selectedCount,
      //   count2: selectedCount,
      //   order_no:orderNo,
      //   time_unit:
      //     meeting?.type === "Action1" ||
      //     meeting?.type === "Newsletter" ||
      //     meeting?.type === "Strategy"
      //       ? "days"
      //       : meeting?.type === "Task"
      //       ? "hours"
      //       : meeting?.type === "Quiz"
      //       ? "seconds"
      //       : meeting?.type === "Special"
      //       ? timeUnit
      //       : "minutes",
      //   time: selectedCount,
      //   editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
      //   editor_content:
      //     modalType === "Editeur" ||
      //     modalType === "Question" ||
      //     modalType === "Email"
      //       ? optimizedEditorContent || ""
      //       : null,
      //   file:
      //     modalType === "File"
      //       ? fileName
      //         ? fileName
      //         : null
      //       : modalType === "Excel"
      //       ? updatedExcelFileUrl || fileName
      //       : fileName,
      //   assigned_to: meeting?.type === "Newsletter" ? null : assignedToUser,
      //   // assigned_to_team: meeting?.type === "Newsletter" ? team?.id : null,
      //   assigned_to_team:
      //     meeting?.type === "Newsletter"
      //       ? meeting?.newly_created_team?.id
      //       : null,
      //   status: "in_progress",
      //   step_status: "in_progress",
      //         current_time: localCurrentTime,
      // current_date: formattedCurrentDate,
      //   url: modalType === "Url" ? (link ? link : null) : null,
      //   // video: modalType === "Video" ? (video ? video : null) : null,
      //   // order_no: stepOrder,
      //   meeting_id: meetingId,
      //   created_by: userID,
      //   // step_status: meeting?.type === "Special" ? "completed" : null,
      //   end_date: meeting?.type === "Special" ? formattedEndDate : null,
      // };
      try {
        setIsValidate(true);
        const response = await axios.post(`${API_BASE_URL}/steps`, payload, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        if (response.status) {
          const stepData = response?.data?.data;

          setIsValidate(false);
          // setId(null);
          setFileUploaded(createAnother ? true : false);
          setCall((prev) => !prev);
          await closeStep();
          // refreshMeeting()
        }
        setSelectedValue("");
        setSelectedOrder(1);
        setOrderNo(null);
        setUser("");
        setTeam("");
        setModifiedFileText("");
        setSelectedCount(0);
        setModalType("");
        setFileName(null);
        setExcelData(null);
        setLink(null);
        setIsValidate(false);
        if (!createAnother) {
          closeModal();
        } else {
          if (meeting?.type === "Newsletter") {
            setModalType("Email");
          } else if (meeting?.type === "Special") {
            setModalType("Audio Report");
          } else if (meeting?.type === "Law") {
            setModalType("Question");
          } else if (meeting?.type === "Google Agenda Event") {
            setModalType("Google Meet Link");
          } else if (meeting?.type === "Absence") {
            setModalType("Absence CET non payable");
          }
          else if (meeting?.type === "Task") {
            setModalType("Subtask")
          } else {
            setModalType("Editeur");
          }
        }
      } catch (error) {
        setIsValidate(false);
        toast.error(t(`meeting.newMeeting.${error?.response?.data?.message}`));
      }
    } else {
      try {
        const optimizedEditorContent = await optimizeEditorContent(
          modifiedFileText
        );
        if (!selectedValue?.trim()) {
          toast.error(t("messages.stepTitle"));
          setIsValidate(false);
          return;
        }
        if (selectedCount === 0) {
          toast.error(t("messages.stepTime"));
          setIsValidate(false);
          return;
        }
        const currentTime = new Date();

        // User's time zone
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Format dates and times
        const formattedEndDate = currentTime.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          timeZone: userTimeZone,
        });
        const assignedToUser =
          user?.id ||
          (meeting?.user_with_participants || meeting?.participants || [])?.find(
            (participant) => participant.email === meeting?.user?.email
          )?.id;
        const payload = {
          title: selectedValue,
          count1: selectedCount || 0,
          count2: selectedCount,
          order_no: selectedOrder || 1,

          time_unit:
            meeting?.type === "Action1" ||
              meeting?.type === "Newsletter" ||
              meeting?.type === "Strategy" || meeting?.type === "Absence"
              ? "days"
              : meeting?.type === "Task"
                ? "hours"
                : meeting?.type === "Quiz"
                  ? "seconds"
                  : meeting?.type === "Special"
                    ? timeUnit
                    : "minutes",


          time: selectedCount,
          // editor_type: modalType,
          editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
          editor_content:
            modalType === "Editeur" ||
              modalType === "Subtask" ||
              modalType === "Question" ||
              modalType === "Email"
              ? optimizedEditorContent || ""
              : [
                "Absence CET non payable",
                "Absence CET payable",
                "Partial unemployment",
                "Paid leave",
                "Corporate event",
                "Skills sponsorship",
                "Recovery",
                "RTT"
              ].includes(modalType)
                ? staticContents[modalType] // Include the static content
                : null,
          file:
            modalType === "File"
              ? fileName
                ? fileName
                : null
              : modalType === "Excel"
                ? updatedExcelFileUrl || fileName
                : fileName, // assigned_to: assignedToUser,
          assigned_to: meeting?.type === "Newsletter" ? null : assignedToUser,
          assigned_to_team:
            meeting?.type === "Newsletter"
              ? null
              : null,

          status: "active",
          url:
            modalType === "Url" || modalType === "Google Meet Link"
              ? link
                ? link
                : null
              : null,
          // order_no: stepOrder,
          meeting_id: meetingId,
          _method: "put",
          // step_status: meeting?.type === "Special" ? "completed" : null,
          end_date: meeting?.type === "Special" ? formattedEndDate : null,
          // google_agenda_update: modalType === "Google Meet Link"? true : false
          google_agenda_update: modalType === "Google Meet Link" || meeting?.agenda === "Google Agenda" ? true : false


        };
        setIsValidate(true);
        const response = await axios.post(
          `${API_BASE_URL}/steps/${id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response.status) {
          // setId(null);
          setIsValidate(false);
          setFileUploaded(createAnother ? true : false);
          setCall((prev) => !prev);
        }
        setSelectedValue("");
        setOrderNo(null);

        setUser("");
        setTeam("");
        setModifiedFileText("");
        setSelectedCount(0);
        setSelectedOrder(1);

        setModalType("");
        setFileName(null);
        setExcelData(null);
        setLink(null);
        setIsValidate(false);
        if (!createAnother) {
          closeModal();
        } else {
          if (meeting?.type === "Newsletter") {
            setModalType("Email");
          } else if (meeting?.type === "Special") {
            setModalType("Audio Report");
          } else if (meeting?.type === "Law") {
            setModalType("Question");
          } else if (meeting?.type === "Google Agenda Event") {
            setModalType("Google Meet Link");
          } else if (meeting?.type === "Absence") {
            setModalType("Absence CET non payable");
          }
          else if (meeting?.type === "Task") {
            setModalType("Subtask")
          } else {
            setModalType("Editeur");
          }
        }
      } catch (error) {
        console.log("error", error);
        setIsValidate(false);
        toast.error(
          t(`meeting.newMeeting.${error?.response?.data?.errors?.title[0]}`)
        );
      }
    }
    // Call refreshMeeting only if it exists
    // if (typeof refreshMeeting === "function") {
    //   refreshMeeting();
    // }
  };

  //FOR REPRENDE STEP
  const validateReprendeStep = async () => {
    // Update Excel file and get the updated file path
    let updatedExcelFileUrl = null;
    let updatedAudioReport = null;
    if (modalType === "Excel") {
      try {
        updatedExcelFileUrl = await updateExcelFile();
      } catch (error) {
        setIsValidate(false);
        return;
      }
    } else if (modalType === "Audio Report" || modalType === "Video Report") {
      try {
        updatedAudioReport = await uploadAudioReport();
      } catch (error) {
        setIsValidate(false);
        return;
      }
    }

    const optimizedEditorContent = await optimizeEditorContent(
      modifiedFileText
    );
    const Steps = [...(meeting?.steps || [])];

    if (!selectedValue?.trim()) {
      toast.error(t("messages.stepTitle"));
      setIsValidate(false);
      return;
    }

    // if (!isUnique) {
    //   toast.error(t("messages.stepNames"));
    //   setIsValidate(false);
    //   return;
    // }

    if (selectedCount === 0) {
      toast.error(t("messages.stepTime"));
      setIsValidate(false);
      return;
    }

    const assignedToUser =
      user?.id ||
    (meeting?.user_with_participants || meeting?.participants || [])?.find(
        // (participant) => participant.email === meeting?.user?.email
        (participant) => participant.email === creator?.email
      )?.id;

    const assignedToYou = (meeting?.user_with_participants || meeting?.participants || [])?.find(
      (participant) => participant.email === SessionUser?.email
    )?.id;

    const currentTime = new Date();

    // User's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Format dates and times
    const formattedEndDate = currentTime.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      timeZone: userTimeZone,
    });
    const localCurrentTime = currentTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const formattedCurrentDate = currentTime.toISOString().split("T")[0];

    // Format date and time in user's timezone
    const stepTimeFormatted = moment().tz(userTimeZone).format("hh:mm:ss A"); // "05:27:40 PM"
    const startDateFormatted = moment().tz(userTimeZone).format("YYYY-MM-DD"); // "2025-04-30"

    const payload = {
      title: selectedValue,
      count1: selectedCount,
      count2: selectedCount,
      order_no: selectedOrder || 1,
      time_unit:
        meeting?.type === "Action1" ||
          meeting?.type === "Newsletter" ||
          meeting?.type === "Strategy" || meeting?.type === "Absence"
          ? "days"
          : meeting?.type === "Task"
            ? "hours"
            : meeting?.type === "Quiz"
              ? "seconds"
              : meeting?.type === "Special"
                ? timeUnit
                : "minutes",
      time: selectedCount,
      editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
      editor_content:
        modalType === "Editeur" ||
          modalType === "Subtask" ||
          modalType === "Question" ||
          modalType === "Email"
          ? optimizedEditorContent || ""
          : [
            "Absence CET non payable",
            "Absence CET payable",
            "Partial unemployment",
            "Paid leave",
            "Corporate event",
            "Skills sponsorship",
            "Recovery",
            "RTT"
          ].includes(modalType)
            ? staticContents[modalType] // Include the static content
            : null,
      file:
        modalType === "File"
          ? fileName
            ? fileName
            : null
          : modalType === "Excel"
            ? updatedExcelFileUrl || fileName
            : fileName,
      assigned_to: meeting?.type === "Newsletter" ? null : assignedToYou,
      assigned_to_team:
        meeting?.type === "Newsletter" ?null: null,
      status: "in_progress",
      step_status: "in_progress",
      current_time: localCurrentTime,
      current_date: formattedCurrentDate,
      url:
        modalType === "Url" || modalType === "Google Meet Link"
          ? link
            ? link
            : null
          : null,
      meeting_id: parseInt(meetingId),
      created_by: userID,
      end_date: meeting?.type === "Special" ? formattedEndDate : null,
      step_time: stepTimeFormatted,
      start_date: startDateFormatted,
      to_resume_check: true
    };

    try {
      setIsValidate(true);
      const response = await axios.post(`${API_BASE_URL}/steps`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.status) {
        const stepData = response?.data?.data;

        setIsValidate(false);
        // setId(null);
        setFileUploaded(createAnother ? true : false);
        setCall((prev) => !prev);
        await closeStep();
        // refreshMeeting()
      }
      setSelectedValue("");
      setOrderNo(null);
      setUser("");
      setTeam("");
      setModifiedFileText("");
      setSelectedCount(0);
      setModalType("");
      setFileName(null);
      setExcelData(null);
      setLink(null);
      setIsValidate(false);
      if (!createAnother) {
        closeModal();
      } else {
        if (meeting?.type === "Newsletter") {
          setModalType("Email");
        } else if (meeting?.type === "Special") {
          setModalType("Audio Report");
        } else if (meeting?.type === "Law") {
          setModalType("Question");
        } else if (meeting?.type === "Google Agenda Event") {
          setModalType("Google Meet Link");
        } else if (meeting?.type === "Absence") {
          setModalType("Absence CET non payable");
        }
        else if (meeting?.type === "Task") {
          setModalType("Subtask")
        } else {
          setModalType("Editeur");
        }
      }
    } catch (error) {
      setIsValidate(false);
      toast.error(t(`meeting.newMeeting.${error?.response?.data?.message}`));
    }
  };
  const [progress, setProgress] = useState(0);
  const [isQuestionProcessing, setIsQuestionProcessing] = useState(false);
  const [questionFinalizing, setQuestionFinalizing] = useState(false); // Track processing after upload

  const validateQuestionStep = async () => {
    if (id == null) {
      setIsQuestionProcessing(true);
      setQuestionFinalizing(false);
      setProgress(0); // Reset progress at the start
      const optimizedEditorContent = await optimizeEditorContent(
        modifiedFileText
      );

      if (!selectedValue?.trim()) {
        toast.error(t("messages.stepTitle"));
        setIsValidate(false);
        setIsQuestionProcessing(false);
        setQuestionFinalizing(false);
        return;
      }

      if (selectedCount === 0) {
        toast.error(t("messages.stepTime"));
        setIsValidate(false);
        setIsQuestionProcessing(false);
        setQuestionFinalizing(false);
        return;
      }

      const assignedToUser =
        user?.id ||
      (meeting?.user_with_participants || meeting?.participants || [])?.find(
          // (participant) => participant.email === meeting?.user?.email
          (participant) => participant.email === creator?.email
        )?.id;

      const payload = {
        order_no: selectedOrder || 1,
        title: selectedValue,
        count1: selectedCount,
        count2: selectedCount,
        time_unit:
          meeting?.type === "Action1" ||
            meeting?.type === "Newsletter" ||
            meeting?.type === "Strategy" || meeting?.type === "Absence"
            ? "days"
            : meeting?.type === "Task"
              ? "hours"
              : meeting?.type === "Quiz"
                ? "seconds"
                : meeting?.type === "Special"
                  ? timeUnit
                  : "minutes",

        time: selectedCount,
        editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
        editor_content:
          modalType === "Editeur" ||
            modalType === "Subtask" ||
            modalType === "Question" ||
            modalType === "Email"
            ? optimizedEditorContent || ""
            : [
              "Absence CET non payable",
              "Absence CET payable",
              "Partial unemployment",
              "Paid leave",
              "Corporate event",
              "Skills sponsorship",
              "Recovery",
              "RTT"
            ].includes(modalType)
              ? staticContents[modalType] // Include the static content
              : null,
        file: null,
        assigned_to: meeting?.type === "Newsletter" ? null : assignedToUser,
        // assigned_to_team: meeting?.type === "Newsletter" ? team?.id : null,
        assigned_to_team:
          meeting?.type === "Newsletter"
            ? null
            : null,
        status: "active",
        url:
          modalType === "Url" || modalType === "Google Meet Link"
            ? link
              ? link
              : null
            : null,
        // video: modalType === "Video" ? (video ? video : null) : null,
        // order_no: stepOrder,
        meeting_id: meetingId,
        created_by: userID,
      };
      try {
        setIsValidate(true);
        const response = await axios.post(`${API_BASE_URL}/steps`, payload, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // Cap progress to 95% during upload
            setProgress(Math.min(percentCompleted, 95));
          },
        });
        if (response.status) {
          setIsValidate(false);
          setQuestionFinalizing(true);
          setProgress(100);
          setTimeout(() => {
            setProgress(0); // Reset progress bar after a short delay
          }, 1000);
          // setId(null);
          // setCall((prev) => !prev);
        }
      } catch (error) {
        setIsValidate(false);
        setUploadProgress(0);
      } finally {
        setIsQuestionProcessing(false);
        setQuestionFinalizing(false);
      }
    } else {
      try {
        const optimizedEditorContent = await optimizeEditorContent(
          modifiedFileText
        );
        const Steps = [...(meeting?.steps || [])];

        if (!selectedValue?.trim()) {
          toast.error(t("messages.stepTitle"));
          setIsValidate(false);
          return;
        }

        if (selectedCount === 0) {
          toast.error(t("messages.stepTime"));
          setIsValidate(false);
          return;
        }
        const assignedToUser =
          user?.id ||
         (meeting?.user_with_participants || meeting?.participants || [])?.find(
            (participant) => participant.email === meeting?.user?.email
          )?.id;
        const payload = {
          order_no: selectedOrder || 1,

          title: selectedValue,
          count1: selectedCount || 0,
          count2: selectedCount,
          time_unit:
            meeting?.type === "Action1" ||
              meeting?.type === "Newsletter" ||
              meeting?.type === "Strategy" || meeting?.type === "Absence"
              ? "days"
              : meeting?.type === "Task"
                ? "hours"
                : meeting?.type === "Quiz"
                  ? "seconds"
                  : meeting?.type === "Special"
                    ? timeUnit
                    : "minutes",


          time: selectedCount,
          // editor_type: modalType,
          editor_type: meeting?.type === "Newsletter" ? "Email" : modalType,
          editor_content:
            modalType === "Editeur" ||
              modalType === "Subtask" ||
              modalType === "Question" ||
              modalType === "Email"
              ? optimizedEditorContent || ""
              : [
                "Absence CET non payable",
                "Absence CET payable",
                "Partial unemployment",
                "Paid leave",
                "Corporate event",
                "Skills sponsorship",
                "Recovery",
                "RTT"
              ].includes(modalType)
                ? staticContents[modalType] // Include the static content
                : null,
          file: null,
          assigned_to: meeting?.type === "Newsletter" ? null : assignedToUser,
          assigned_to_team:
            meeting?.type === "Newsletter"
              ? null
              : null,

          status: "active",
          url:
            modalType === "Url" || modalType === "Google Meet Link"
              ? link
                ? link
                : null
              : null,
          // order_no: stepOrder,
          meeting_id: meetingId,
          _method: "put",
        };
        setIsValidate(true);
        setIsQuestionProcessing(true);
        setQuestionFinalizing(false);
        setProgress(0); // Reset progress at the start

        const response = await axios.post(
          `${API_BASE_URL}/steps/${id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(Math.min(percentCompleted, 95));
            },
          }
        );
        if (response.status) {
          // setId(null);
          setIsValidate(false);
          // setCall((prev) => !prev);
          setQuestionFinalizing(true);
          setProgress(100);
          setTimeout(() => {
            setProgress(0); // Reset progress bar after a short delay
          }, 1000);
        }
      } catch (error) {
        setProgress(0);
        setIsValidate(false);
      } finally {
        setIsQuestionProcessing(false);
        setQuestionFinalizing(false);
      }
    }

    setSelectedValue("");
    setOrderNo(null);
    setSelectedOrder(1);

    setUser("");
    setTeam("");
    setModifiedFileText("");
    setSelectedCount(0);
    setModalType("");
    setFileName(null);
    setExcelData(null);
    setLink(null);
    setIsValidate(false);
    if (!createAnother) {
      closeModal();
    } else {
      if (meeting?.type === "Newsletter") {
        setModalType("Email");
      } else if (meeting?.type === "Special") {
        setModalType("Audio Report");
      } else if (meeting?.type === "Law") {
        setModalType("Question");
      } else if (meeting?.type === "Google Agenda Event") {
        setModalType("Google Meet Link");
      } else if (meeting?.type === "Absence") {
        setModalType("Absence CET non payable");
      }
      else if (meeting?.type === "Task") {
        setModalType("Subtask")
      } else {
        setModalType("Editeur");
      }
    }
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleOpenDialog = () => {
    setShowConfirmation(true);
  };
  const handleClose = () => {
    setShowConfirmation(false);
    setFileUploaded(false);
  };

  const cancelStep = () => {
    setShowConfirmation(false);
    closeModal();
    // setId(null);
    setCreateAnother(false);
    setSelectedValue("");
    setSelectedOrder(1);
    setOrderNo(null);

    setUser("");
    setTeam("");
    setModifiedFileText("");
    setSelectedCount(0);
    setModalType("");
    setFileName(null);
    setExcelData(null);
    setLink(null);
    setIsValidate(false);
    setFileUploaded(false);
  };

  const [stepCreator, setStepCreator] = useState(null);
  const [stepCreatorImg, setStepCreatorImg] = useState(null);
  const [step, setStep] = useState(null);
  useEffect(() => {
    const getStep = async () => {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(currentTime.toLocaleString("en-US", options));

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/steps/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        if (response.status === 200) {
          const stepData = response.data?.data;
          setStep(response?.data?.data);
          setLink(stepData?.url);
          setShowPreview(true);
          setPreviewUrl(stepData?.url);
          setSelectedValue(stepData?.title);
          setSelectedOrder(stepData?.order_no);

          setStepCreator(
            stepData?.step_creator?.full_name
              ? stepData?.step_creator?.full_name
              : stepData?.assigned_to_name
          );
          setStepCreatorImg(
            stepData?.step_creator?.image
              ? stepData?.step_creator?.image
              : stepData?.assigned_to_image || stepData?.image
          );
          setModifiedFileText(stepData?.editor_content);
          setAssignUser(response.data?.data?.assigned_to_name);
          setSelectedCount(stepData?.count2 || 0);
          setOrderNo(stepData?.order_no);
          setUser(response.data?.data?.participant);
          setTeam(response.data?.data?.assigned_team);
          setTimeUnit(stepData?.time_unit);
          setFileName(stepData?.file);
          if (stepData?.editor_type === "Excel") {
            const fileResponse = await axios.get(
              Assets_URL + "/" + stepData?.file,
              {
                responseType: "arraybuffer",
              }
            );
            const fileData = fileResponse.data;
            const workbook = read(fileData, { type: "buffer" });

            // Convert the first sheet to JSON
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonSheetData = utils.sheet_to_json(worksheet, { header: 1 });

            const formattedData = jsonSheetData.map((row, rowIndex) =>
              row.map((cell, cellIndex) => ({
                value: cell,
                readOnly: rowIndex === 0,
              }))
            );
            setExcelData(formattedData);
          }
          setModalType(stepData?.editor_type);

          // setFileUploaded(false)

          // setIsUpdate(true);
          if (id && !isDrop) {
            setIsUpdate(true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      getStep();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const stepTime = step?.step_time;
      const stepDate = step?.start_date;
      const meetingTimezone = meeting?.timezone || "Europe/Paris";

      if (stepTime && stepDate && meetingTimezone) {
        const userTimezone = moment.tz.guess();

        // Convert date and time to user's timezone
        const dateTimeInMeetingTZ = moment.tz(
          `${stepDate} ${stepTime}`,
          "YYYY-MM-DD hh:mm:ss A",
          meetingTimezone
        );
        const dateTimeInUserTZ = dateTimeInMeetingTZ.clone().tz(userTimezone);

        // const timeParts = stepTime.split(" "); // Split by space to separate time and AM/PM
        // if (timeParts.length < 2) return; // Guard condition

        // const [hour, minute, second] = timeParts[0].split(":"); // Get hour, minute, second
        // const amPm = timeParts[1];

        // // Convert to 24-hour format safely
        // const hourInt = parseInt(hour, 10);
        // const hour24 =
        //   amPm === "PM" && hourInt !== 12
        //     ? hourInt + 12
        //     : amPm === "AM" && hourInt === 12
        //     ? "00"
        //     : hourInt.toString().padStart(2, "0");

        // Format time in 24-hour format
        const formattedTime =
          step?.time_unit === "seconds"
            ? dateTimeInUserTZ.format("HH[h]mm[m]ss")
            : dateTimeInUserTZ.format("HH[h]mm");

        setStoredStartTime(formattedTime);

        // Format date as DD/MM/YYYY
        const formattedDate = dateTimeInUserTZ.format("DD/MM/YYYY");
        // const formattedDate = moment(stepDate, "YYYY-MM-DD").format(
        //   "DD/MM/YYYY"
        // );
        setStoredStartDate(formattedDate);
        setStoredStartDateForHour(formattedDate);
      }
    } else if (meeting?.steps?.length > 0) {
      const lastStep = meeting.steps[meeting.steps.length - 1];
      const lastStepTime = lastStep?.step_time;
      const lastStepDate = lastStep?.start_date;
      const count2 = lastStep?.count2 || 0;
      const timeUnit = lastStep?.time_unit;
      const meetingTimezone = meeting?.timezone || "Europe/Paris";

      if (!lastStepTime || !lastStepDate) return; // Ensure time exists

      const userTimezone = moment.tz.guess();

      // Convert date and time to user's timezone
      const dateTimeInMeetingTZ = moment.tz(
        `${lastStepDate} ${lastStepTime}`,
        "YYYY-MM-DD hh:mm:ss A",
        meetingTimezone
      );
      const dateTimeInUserTZ = dateTimeInMeetingTZ.clone().tz(userTimezone);

      // const timeParts = lastStepTime.split(" ");
      // if (timeParts.length < 2) return;

      // const [hour, minute, second] = timeParts[0].split(":");
      // const amPm = timeParts[1];

      // let hourInt = parseInt(hour, 10);
      // let minuteInt = parseInt(minute, 10);
      // let secondInt = parseInt(second, 10) || 0;

      // // Convert 12-hour time format to 24-hour format
      // if (amPm === "PM" && hourInt !== 12) {
      //   hourInt += 12;
      // } else if (amPm === "AM" && hourInt === 12) {
      //   hourInt = 0;
      // }

      // Create a moment object with the extracted time
      // let stepMoment = moment()
      //   .hours(hourInt)
      //   .minutes(minuteInt)
      //   .seconds(secondInt);

      // Add `count2` based on `time_unit` in user timezone
      if (timeUnit === "seconds") {
        dateTimeInUserTZ.add(count2, "seconds");
      } else if (timeUnit === "minutes") {
        dateTimeInUserTZ.add(count2, "minutes");
      } else if (timeUnit === "hours") {
        dateTimeInUserTZ.add(count2, "hours");
      } else if (timeUnit === "days") {
        dateTimeInUserTZ.add(count2, "days");
      }

      // Format the updated time in 24-hour format
      const formattedTime =
        timeUnit === "seconds"
          ? dateTimeInUserTZ.format("HH[h]mm[m]ss")
          : dateTimeInUserTZ.format("HH[h]mm");

      setStoredStartTime(formattedTime);

      // Convert lastStepDate and add count2 to it in user's timezone
      const formattedDate = dateTimeInUserTZ.format("DD/MM/YYYY");

      setStoredStartDate(formattedDate);
      setStoredStartDateForHour(formattedDate);
    } else {
      const stepTime = meeting?.start_time;
      const stepDate = meeting?.date;
      const meetingTimezone = meeting?.timezone || "Europe/Paris";

      if (!stepTime || !stepDate) return; // Guard condition
      const userTimezone = moment.tz.guess();

      // Convert date and time to user's timezone
      const dateTimeInMeetingTZ = moment.tz(
        `${stepDate} ${stepTime}`,
        "YYYY-MM-DD hh:mm:ss A",
        meetingTimezone
      );
      const dateTimeInUserTZ = dateTimeInMeetingTZ.clone().tz(userTimezone);
      const formattedTime =
        step?.time_unit === "seconds"
          ? dateTimeInUserTZ.format("HH[h]mm[m]ss")
          : dateTimeInUserTZ.format("HH[h]mm");

      // const [hour, minute, second] = stepTime.split(":"); // Extract hour, minute, second

      // const formattedTime =
      //   step?.time_unit === "seconds"
      //     ? `${hour}h${minute}m${second}`
      //     : `${hour}h${minute}`;

      setStoredStartTime(formattedTime);

      const formattedDate = dateTimeInUserTZ.format("DD/MM/YYYY");

      setStoredStartDate(formattedDate);
      setStoredStartDateForHour(formattedDate);
    }
  }, [step, id, meeting]);

  useEffect(() => {
    if (id || step) {
      // If editing, select the step's current order
      setSelectedOrder(step?.order_no);
    } else {
      // If adding a new step, auto-select the latest order
      setSelectedOrder((meeting?.steps?.length || 0) + 1);
    }
  }, [meeting?.steps, step, id]); // Update when steps or editing step changes

  const [isDeleted, setIsDeleted] = useState(false);
  const deleteStep = async () => {
    try {
      setIsDeleted(true);

      const response = await axios.delete(`${API_BASE_URL}/steps/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });

      if (response.data) {
        toast.success(t("messages.stepDeleted"));
        const updatedSteps = meeting?.steps?.filter((step) => step.id !== id);

        const reorderedSteps = updatedSteps.map((step, index) => ({
          ...step,
          order_no: index + 1,
        }));

        // Attempt to reorder the steps, but do not block further execution if it fails
        try {
          await axios.post(
            `${API_BASE_URL}/steps/reorder`,
            {
              meeting_id: meeting?.id,
              steps: reorderedSteps.map((step) => ({
                id: step.id,
                order_no: step.order_no, // Pass updated order_no to API
              })),
              _method: "post",
            },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );
        } catch (error) {
          console.error("Reorder API failed:", error);
          // toast.error("Failed to reorder steps.");
        }

        closeModal();
        setCreateAnother(false);
        setSelectedValue("");
        setSelectedOrder(1);
        setUser("");
        setTeam("");
        setModifiedFileText("");
        setSelectedCount(0);
        setModalType("");
        setFileName(null);
        setExcelData(null);
        setLink(null);
        setIsValidate(false);
        setIsUpdate(false);
        setCall((prev) => !prev);

        // Ensure refreshMeeting is always called, regardless of reorder success
        // if (typeof refreshMeeting === "function") {
        //   refreshMeeting();
        // }
      }
    } catch (error) {
      console.error("Delete API failed:", error);
    } finally {
      setIsDeleted(false);
    }
  };

  const [error, setError] = useState("");

  const handleLinkUpload = (e) => {
    const url = e.target.value;
    setLink(url);

    if (url && !isYoutubeUrl(url)) {
      setError(t("YoutubeLink"));
    } else {
      setError(""); // Clear error if the link is valid
    }
  };

  const clearLink = () => {
    setLink("");
    setError(""); // Clear error when clearing the input
  };

  const isYoutubeUrl = (url) => {
    const regex = /(youtube\.com|youtu\.be)/;
    return regex.test(url);
  };
  const getYoutubeEmbedUrl = (url) => {
    const videoId = url.split("v=")[1] || url.split("/").pop();
    return `https://www.youtube.com/embed/${videoId}`;
  };

  const [teams, setTeams] = useState([]);
  useEffect(() => {
    const getTeams = async () => {
      const token = sessionStorage.getItem("token");
      try {
        setLoading(true);

        const response = await axios.get(`${API_BASE_URL}/teams`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          const filterredActiveTeams = response?.data?.data?.filter(
            (team) => team.status === "active"
          );
          if (getUserRoleID() === 3) {
            // setAllTeams(response?.data?.data);
            const teams = response.data.data.filter(
              (team) => team?.enterprise?.id === response?.data?.enterprise?.id
            );
            setTeams(teams);
          } else {
            // setAllTeams(response?.data?.data);
            const teams = response.data.data.filter(
              (team) => team?.enterprise?.id === response?.data?.enterprise?.id
            );
            setTeams(teams);
          }
        }
      } catch (error) {
        toast.error(t(error?.response?.data?.errors[0] || error?.message));
        // console.log("error message", error);
      } finally {
        setLoading(false);
      }
    };
    getTeams();
  }, [userID, checkId]);

  return (
    <>
      {show && (
        <div id="chart-container" className="chart-content">
          <div className="modal-overlay">
            <div className="modal-content" style={{ overflow: "unset" }}>
              <div className="d-flex justify-content-end p-3">
                <button className="cross-btn" onClick={deleteStepX}>
                  <RxCross2 size={18} />
                </button>
              </div>
              <div
                className="d-flex flex-wrap"
                style={{ borderBottom: "1px solid #EAECF0" }}
              >
                <div className="col-lg-4">
                  <div className="input-field step-inputfield">
                    {meeting?.type === "Task" ||
                      meeting?.type === "Strategy" ? (
                      <select
                        className="form-select form-select-sm addstep-width"
                        aria-label="Step Number"
                        value={selectedOrder}
                        onChange={(e) =>
                          setSelectedOrder(Number(e.target.value))
                        }
                      >
                        {Array.from(
                          { length: meeting?.steps.length + 1 || 1 },
                          (_, i) => i + 1
                        ).map((order) => (
                          <option key={order} value={order}>
                            {order}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <select
                        className="form-select form-select-sm addstep-width
                                  "
                        aria-label="Step Number"
                        defaultValue={selectedOrder}
                      >
                        <option value={selectedOrder}>
                          {selectedOrder}
                        </option>
                      </select>
                    )}
                    <input
                      className="text-left form-control"
                      type="text"
                      placeholder={t("stepModal.title")}
                      value={selectedValue}
                      onChange={handleChange1}
                      style={{ padding: "9px" }}
                      disabled={disabled}
                    />
                  </div>
                </div>
                <div className="col editor-header">
                  <div className="p-0 timecard stepinfo">
                    <p className="mb-0">{t("meeting.newMeeting.The stage starts at")}</p>
                    {meeting?.type === "Newsletter" ? (
                      <>
                        <h6 style={{ fontSize: "14px" }}>
                          {storedStartDate === "Invalid date"
                            ? "Date à compléter"
                            : storedStartDate}
                        </h6>
                      </>
                    ) : (
                      <>
                        <span className="step-time text-start m-0">
                          {step?.start_date
                            ? new Date(step.start_date).toLocaleDateString(
                              "en-GB"
                            )
                            : ""}
                        </span>
                        <h5 className="step-time mb-0 pb-0">
                          {storedStartTime === "Invalid date"
                            ? "Date à compléter"
                            : storedStartTime}
                        </h5>
                      </>
                    )}
                  </div>
                </div>
                <div className="col editor-header">
                  <div className="p-0 timecard stepinfo">
                    {!window.location.href.includes("/meetingDetail") && (
                      <div className="p-0 timecard ">
                        <p className="mb-2">
                          {t("meeting.newMeeting.Step duration")}
                        </p>
                        <div className="d-flex justify-content-start">
                          <div className="d-flex align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              onClick={() => {
                                handleDecrementCount();
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <rect
                                x="0.800049"
                                width="16"
                                height="16"
                                rx="4"
                                fill="white"
                              />
                              <path
                                d="M4.13342 8H13.4668"
                                stroke="#8280FF"
                                stroke-width="1.33333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>

                            {/* <span className="step-timer step-time">
                              {selectedCount}
                            </span> */}
                            <input
                              type="text"
                              value={selectedCount}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  // This regex allows only digits (0-9)
                                  setSelectedCount(value);
                                }
                              }}
                              disabled={disabled}
                              className="step-timer step-time"
                              style={{
                                width: "25px",
                                padding: "0",
                                outline: "none",
                              }}
                            />

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              onClick={() => {
                                handleIncrementCount();
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <rect
                                x="0.600098"
                                width="16"
                                height="16"
                                rx="4"
                                fill="white"
                              />
                              <path
                                d="M8.6001 3.5V12.5M13.1001 8H4.1001"
                                stroke="#8280FF"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                          <div>
                            {meeting?.type === "Action1" ||
                              meeting?.type === "Newsletter" ||
                              meeting?.type === "Strategy" || meeting?.type === "Absence" ? (
                              <span> {t("days")} </span>
                            ) : meeting?.type === "Task" ? (
                              <span> {t("hour")} </span>
                            ) : meeting?.type === "Quiz" ? (
                              <span> {t("sec")} </span>
                            ) : meeting?.type === "Special" ? (
                              <span> {t(`time_unit.${timeUnit}`)} </span>
                            ) : (
                              <span> mins </span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col editor-header">
                  <div className="p-0 timecard stepinfo">
                    {!window.location.href.includes("/meetingDetail") && (
                      <div
                        className="p-0 timecard "
                        style={{ marginBottom: "4px" }}
                      >
                        <p className="mb-2">
                          {t("meeting.newMeeting.Step creator")}
                        </p>
                        <div className="d-flex justify-content-start">
                          <div>
                            {meeting?.type === "Newsletter" ? (
                              <>
                                <img
                                  src={
                                    creator?.image?.startsWith("http")
                                      ? creator?.image
                                      : Assets_URL + "/" + creator?.image
                                  }
                                  alt={creator?.full_name}
                                  style={{
                                    borderRadius: "50%",
                                    height: "30px",
                                    width: "30px",
                                    objectFit: "cover",
                                    objectPosition: "top",
                                  }}
                                />
                                <span className="ml-2 step-time">
                                  {creator?.full_name}
                                </span>
                              </>
                            ) : (
                              <>
                                <img
                                  src={
                                    id
                                      ? stepCreatorImg?.startsWith("http")
                                        ? stepCreatorImg
                                        : Assets_URL + "/" + stepCreatorImg
                                      : creator?.image?.startsWith("http")
                                        ? creator?.image
                                        : Assets_URL + "/" + creator?.image
                                  }
                                  alt={id ? stepCreator : creator?.full_name}
                                  style={{
                                    borderRadius: "50%",
                                    height: "30px",
                                    width: "30px",
                                    objectFit: "cover",
                                    objectPosition: "top",
                                  }}
                                />
                                <span className="ml-2 step-time">
                                  {id ? stepCreator : creator?.full_name}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col editor-header">
                  <div className="p-0 timecard stepinfo">
                    {!window.location.href.includes("/meetingDetail") && (
                      <div className="p-0 timecard ">
                        <div className="d-flex justify-content-start">
                          <div className="Editor-custom-dropdown">
                            {meeting?.type === "Newsletter" ? (
                              <>
                                <p className="mb-2">
                                  {t("meeting.newMeeting.team")}
                                </p>
                                <span className="step-time m-0">
                                  {`${meeting?.newsletter_guide?.name}`}
                                </span>
                              </>
                            ) : (
                              <>
                                <p className="mb-2">
                                  {t("meeting.newMeeting.Step presenter")}
                                </p>
                                <div
                                  className="editor-dropdown-header p-0"
                                  onClick={() =>
                                    setStepPresentor(!StepPresentor)
                                  }
                                >
                                  <div className="d-flex align-items-center gap-1">
                                    <div className="selected-user">
                                      {user ? (
                                       <img
                                                                                 src={
                                                                                  (meeting?.user_with_participants || meeting?.participants || [])
                                                                                     ?.find(
                                                                                       (participant) =>
                                                                                         participant.id === user?.id
                                                                                     )
                                                                                     ?.participant_image?.startsWith(
                                                                                       "http"
                                                                                     )
                                                                                     ? (meeting?.user_with_participants || meeting?.participants || [])?.find(
                                                                                         (participant) =>
                                                                                           participant.id === user?.id
                                                                                       )?.participant_image
                                                                                     : Assets_URL +
                                                                                     "/" +
                                                                                     (meeting?.user_with_participants || meeting?.participants || [])?.find(
                                                                                       (participant) =>
                                                                                         participant.id === user?.id
                                                                                     )?.participant_image
                                                                                 }
                                                                                 className="rounded-circle"
                                                                                 style={{
                                                                                   borderRadius: "50%",
                                                                                   height: "30px",
                                                                                   width: "30px",
                                                                                   objectFit: "cover",
                                                                                   objectPosition: "top",
                                                                                 }}
                                                                                 alt="Avatar"
                                                                               />
                                      ) : (
                                        <img
                                          src={
                                                                                     creator?.image?.startsWith("http")
                                                                                       ? creator?.image
                                                                                       : Assets_URL +
                                                                                       "/" +
                                                                                       creator?.image
                                                                                   }
                                          className="rounded-circle"
                                          style={{
                                            borderRadius: "50%",
                                            height: "30px",
                                            width: "30px",
                                            objectFit: "cover",
                                            objectPosition: "top",
                                          }}
                                          alt="Avatar1"
                                        />
                                      )}
                                    </div>
                                    {user ? user.full_name : creator?.full_name}  {getLabelForParticipant(user?.email || creator?.email) && (
                                      getStatusLabel(getLabelForParticipant(user?.email || creator?.email))
                                    )}
                                  </div>
                                  <ExpandIcon />
                                </div>
                                {StepPresentor && (
                                  <ul className="editor-dropdown-list">
                                    {(meeting?.user_with_participants || meeting?.participants || [])?.length ===
                                      0 ? (
                                      <li>{t("No Guests Available")}</li>
                                    ) : (
                                      <>
                                        {(meeting?.user_with_participants || meeting?.participants || [])
                                          ?.reduce(
                                            (uniqueParticipants, item) => {
                                              const isDuplicate =
                                                uniqueParticipants.some(
                                                  (participant) =>
                                                    participant.first_name ===
                                                    item.first_name &&
                                                    participant.last_name ===
                                                    item.last_name &&
                                                    participant.email ===
                                                    item.email &&
                                                    participant.post ===
                                                    item.post
                                                );
                                              if (!isDuplicate) {
                                                uniqueParticipants.push(item);
                                              }
                                              return uniqueParticipants;
                                            },
                                            []
                                          )
                                          .map((item, index) => {
                                            // Handle case where no valid participant information is available
                                            return item.first_name === null &&
                                              item.last_name === null &&
                                              item.email === null &&
                                              item.post === null ? (
                                              <li key={index} disabled>
                                                {t(
                                                  "meeting.newMeeting.No Guest Available"
                                                )}
                                              </li>
                                            ) : (
                                              // Render each participant as an li element
                                              <li
                                                key={index}
                                                value={item.id}
                                                onClick={() =>
                                                  handleUserSelect(item)
                                                }
                                                disabled={
                                                  window.location.href.includes(
                                                    "/meetingDetail"
                                                  ) || fromReport
                                                }
                                              >
                                                <img
                                                  src={
                                                                                                      item?.participant_image?.startsWith(
                                                                                                        "http"
                                                                                                      )
                                                                                                        ? item.participant_image
                                                                                                        :  Assets_URL +
                                                                                                        "/" +
                                                                                                        item.participant_image
                                                                                                    }
                                                  className="rounded-circle"
                                                  style={{
                                                    borderRadius: "50%",
                                                    height: "30px",
                                                    width: "30px",
                                                    objectFit: "cover",
                                                    objectPosition: "top",
                                                  }}
                                                  alt="Avatar"
                                                />

                                                {`${item.first_name || item?.name
                                                  } ${item.last_name}`}
                                                {getLabelForParticipant(item.email) && (
                                                  getStatusLabel(getLabelForParticipant(item.email))
                                                )}
                                              </li>
                                            );
                                          })}
                                      </>
                                    )}
                                  </ul>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col editor-header">
                  <div className="p-0 timecard stepinfo">
                    {!window.location.href.includes("/meetingDetail") && (
                      <div className="p-0 timecard ">
                        <p className="mb-2">
                          {t("meeting.newMeeting.Step format")}
                        </p>
                        <div className="d-flex justify-content-start">
                          <div className="Editor-custom-dropdown">
                            <div
                              className="editor-dropdown-header"
                              onClick={() => setIsOpen(!isOpen)}
                            >
                            {modalType === "Editeur"
                               ? t("stepModal.editor")
                               : modalType === "File"
                               ? t("stepModal.pdf")
                               : modalType === "Video"
                               ? t("stepModal.video")
                               : modalType === "Subtask"
                               ? t("stepModal.subtask")
                               : modalType === "Video Report"
                               ? t("stepModal.videoReport")
                               : modalType === "Audio Report"
                               ? t("stepModal.audioReport")
                               : modalType === "Photo"
                               ? t("stepModal.photo")
                               : modalType === "Email"
                               ? t("stepModal.email")
                               : modalType === "Url"
                               ? t("stepModal.url")
                               : modalType === "Excel"
                               ? t("stepModal.excel")
                               : modalType === "PowerPoint"
                               ? t("stepModal.powerpoint")
                               : modalType === "Google Meet Link"
                               ? t("stepModal.googleMeetLink")
                               : modalType === "Question"
                               ? t("stepModal.laweditor")
                               : modalType === "Message" ? t("stepModal.message")
                               : modalType === "Absence CET non payable"
                               ? t("meeting.absence_step_type.absence_type_1")
                               : modalType === "Absence CET payable"
                               ? t("meeting.absence_step_type.absence_type_2")
                               : modalType === "Partial unemployment"
                               ? t("meeting.absence_step_type.absence_type_3")
                               : modalType === "Paid leave"
                               ? t("meeting.absence_step_type.absence_type_4")
                               : modalType === "Corporate event"
                               ? t("meeting.absence_step_type.absence_type_5")
                               : modalType === "Skills sponsorship"
                               ? t("meeting.absence_step_type.absence_type_6")
                               : modalType === "Recovery"
                               ? t("meeting.absence_step_type.absence_type_7")
                               : modalType === "RTT"
                               ? t("meeting.absence_step_type.absence_type_8")
                               : modalType}
                              <ExpandIcon />
                            </div>
                            {isOpen && (
                              <ul className="editor-dropdown-list">
                                {meeting?.type === "Newsletter" ? (
                                  <>
                                    {newsletterOption.map((option) => (
                                      <li
                                        key={option.value}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option.icon} {option.label}
                                      </li>
                                    ))}
                                  </>
                                ) : meeting?.type === "Law" ? (
                                  <>
                                    {LawOption.map((option) => (
                                      <li
                                        key={option.value}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option.icon} {option.label}
                                      </li>
                                    ))}
                                  </>
                                ) : meeting?.type === "Absence" ? (
                                  <>
                                  {AbsenceOption.map((option) => (
                                    <li
                                      key={option.value}
                                      className="dropdown-item"
                                      onClick={() => handleSelect(option)}
                                    >
                                      {option.icon} {option.label}
                                    </li>
                                  ))}
                                  
                                  </>
                                ) : meeting?.type === "Task" ? (
                                  <>
                                    {taskOption.map((option) => (
                                      <li
                                        key={option.value}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option.icon} {option.label}
                                      </li>
                                    ))}
                                  </>
                                ) : meeting?.type === "Special" ? (
                                  <>
                                    {SpecialMeetingOptions.map((option) => (
                                      <li
                                        key={option.value}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option.icon} {option.label}
                                      </li>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {options.map((option) => (
                                      <li
                                        key={option.value}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option.icon} {option.label}
                                      </li>
                                    ))}
                                  </>
                                )}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="modal-body"
                style={{
                  background: "#F2F4FB",
                  height: "90vh",
                  minHeight: "90vh",
                  padding: 0

                }}
              >
                {(isProcessing || finalizing) && (
                  <div className="progress-container">
                    <div
                      className="progress"
                      style={{ width: `${uploadProgress}%` }}
                    />
                  </div>
                )}
                {(isQuestionProcessing || questionFinalizing) && (
                  <div className="progress-container">
                    <div
                      className="progress"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                )}
                <div>
                  <div className="row">
                    {modalType === "Editeur" ||
                      modalType === "Subtask" ||
                      modalType === "Question" ||
                      modalType === "Email" ? (
                      <div className="col-md-12">
                        <div>
                          <Editor
                            disabled={fromReport}
                            className="editor-no-border text_editor"
                            // id="text_editor"
                            apiKey={TINYMCEAPI}
                            value={modifiedFileText}
                            name="text"
                            init={{
                              statusbar: false,
                              branding: false,
                              height: 450,
                              border: "none",
                              menubar: true,
                              language: "fr_FR",
                              plugins:
                                meeting?.type === "Law"
                                  ? "print preview paste searchreplace autolink directionality visualblocks visualchars fullscreen link template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount textpattern"
                                  : "print preview paste searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                              toolbar:
                                meeting?.type === "Law"
                                  ? "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat"
                                  : "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | image | link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                              image_advtab: meeting?.type !== "Law",
                              file_picker_types:
                                meeting?.type === "Law" ? "" : "image media",
                              file_picker_callback: function (
                                callback,
                                value,
                                meta
                              ) {
                                if (
                                  meta.filetype === "image" &&
                                  meeting?.type !== "Law"
                                ) {
                                  const input = document.createElement("input");
                                  input.setAttribute("type", "file");
                                  input.setAttribute("accept", "image/*");

                                  input.onchange = function () {
                                    const file = input.files[0];
                                    const reader = new FileReader();

                                    reader.onload = function (e) {
                                      const img = new Image();
                                      img.src = e.target.result;

                                      img.onload = function () {
                                        const canvas =
                                          document.createElement("canvas");
                                        const ctx = canvas.getContext("2d");
                                        const maxWidth = 700;
                                        const maxHeight = 394;

                                        let newWidth = img.width;
                                        let newHeight = img.height;

                                        if (img.width > maxWidth) {
                                          newWidth = maxWidth;
                                          newHeight =
                                            (img.height * maxWidth) / img.width;
                                        }

                                        if (newHeight > maxHeight) {
                                          newHeight = maxHeight;
                                          newWidth =
                                            (img.width * maxHeight) /
                                            img.height;
                                        }

                                        canvas.width = newWidth;
                                        canvas.height = newHeight;

                                        ctx.drawImage(
                                          img,
                                          0,
                                          0,
                                          newWidth,
                                          newHeight
                                        );

                                        const resizedImageData =
                                          canvas.toDataURL(file.type);
                                        callback(resizedImageData, {
                                          alt: file.name,
                                        });
                                      };

                                      img.src = e.target.result;
                                    };

                                    reader.readAsDataURL(file);
                                  };

                                  input.click();
                                }
                              },
                              setup: (editor) => {
                                // Disable pasting images and media
                                editor.on("paste", (event) => {
                                  if (meeting?.type === "Law") {
                                    const clipboard =
                                      event.clipboardData ||
                                      window.clipboardData;
                                    const items = clipboard.items || [];
                                    for (const item of items) {
                                      if (
                                        item.type.startsWith("image") ||
                                        item.type.startsWith("video")
                                      ) {
                                        event.preventDefault();
                                        console.warn(
                                          "Pasting images and videos is not allowed for 'Law' type content."
                                        );
                                        return;
                                      }
                                    }
                                  }
                                });
                              },
                            }}
                            onEditorChange={(content) => {
                              setModifiedFileText(content);
                            }}
                          />
                        </div>
                        <div></div>
                      </div>
                    ) : modalType === "Absence CET non payable" ||
                    modalType === "Absence CET payable" ||
                    modalType === "Partial unemployment" ||
                    modalType === "Paid leave" ||
                    modalType === "Corporate event" ||
                    modalType === "Skills sponsorship" ||
                    modalType === "Recovery" ||
                    modalType === "RTT" ? (
                         <div className="col-md-12">
                                            <div>
                                               <textarea
                            style={{
                              width: '100%',
                              minHeight: '450px',
                              whiteSpace: 'pre-wrap', // Preserve line breaks
                              lineHeight: '1.5', // Better readability
                              padding: '10px',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              backgroundColor: '#f9f9f9',
                              // cursor: 'not-allowed' // Indicate readonly
                              outline:'none'
                            }}
                            value={staticContents[modalType] || ''}
                            readOnly
                          />
                                            </div>
                                            <div></div>
                                          </div>
                    ): modalType === "File" ||
                      modalType === "Video" ||
                      modalType === "Excel" ||
                      modalType === "Photo" ||
                      modalType === "Video Report" ||
                      modalType === "Audio Report" ? (
                      <>
                        <div className="col-md-12 p-4">
                          {!isUpload ? (
                            <>
                              <div
                                className={`d-flex align-items-center gap-4 ${fileName ? "" : "h-100"
                                  }`}
                              >
                                <div
                                  {...getRootProps()}
                                  style={{
                                    border: "1px dashed #BAC3D4",
                                    padding: "5px 7px",
                                    width: fileName ? "auto" : "100%",
                                    borderRadius: "50px",
                                    outline: "none",
                                    margin: fileName ? "" : "0 auto",
                                    height: fileName ? "auto" : "80vh",
                                    cursor: "pointer",
                                  }}
                                >
                                  <input {...getInputProps()} />
                                  {isUpload ? (
                                    <p>Uploading...</p>
                                  ) : fileName ? (
                                    <div>Selected file: {fileName}</div>
                                  ) : (
                                    <>
                                      <p className="upload-container">
                                        <span className="upload-text">
                                          Drag and drop here to upload
                                        </span>
                                        <span className="upload-or">OR</span>
                                        <span className="browse-button">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M10.2083 2.36166C9.82496 2.29666 9.30163 2.29166 8.35829 2.29166C6.76079 2.29166 5.62496 2.29332 4.76496 2.40832C3.92163 2.52082 3.43746 2.73332 3.08496 3.08499C2.73246 3.43749 2.52079 3.92082 2.40829 4.75916C2.29329 5.61582 2.29163 6.74416 2.29163 8.33416V11.6675C2.29163 13.2558 2.29329 14.3842 2.40829 15.2408C2.52079 16.0792 2.73246 16.5625 3.08496 16.9158C3.43746 17.2675 3.92079 17.4792 4.75913 17.5917C5.61579 17.7075 6.74413 17.7083 8.33329 17.7083H11.6666C13.2558 17.7083 14.385 17.7067 15.2416 17.5917C16.0791 17.4792 16.5625 17.2675 16.915 16.915C17.2675 16.5625 17.4791 16.0792 17.5916 15.2408C17.7066 14.385 17.7083 13.2558 17.7083 11.6667V11.3025C17.7083 10.0225 17.7 9.41582 17.5633 8.95832H14.955C14.0108 8.95832 13.24 8.95832 12.63 8.87666C11.9941 8.79082 11.4425 8.60582 11.0016 8.16499C10.5608 7.72416 10.3758 7.17332 10.29 6.53582C10.2083 5.92749 10.2083 5.15582 10.2083 4.21082V2.36166ZM11.4583 3.00832V4.16666C11.4583 5.16666 11.46 5.85332 11.5291 6.36916C11.5958 6.86749 11.7158 7.11166 11.8858 7.28082C12.055 7.45082 12.2991 7.57082 12.7975 7.63749C13.3133 7.70666 14 7.70832 15 7.70832H16.6833C16.3635 7.40382 16.0385 7.10488 15.7083 6.81166L12.4091 3.84249C12.0979 3.558 11.7809 3.27988 11.4583 3.00832ZM8.47913 1.04166C9.63329 1.04166 10.3791 1.04166 11.065 1.30416C11.7508 1.56749 12.3025 2.06416 13.1566 2.83332L13.2458 2.91332L16.5441 5.88249L16.6483 5.97582C17.635 6.86332 18.2733 7.43749 18.6158 8.20749C18.9591 8.97749 18.9591 9.83582 18.9583 11.1625V11.7133C18.9583 13.245 18.9583 14.4583 18.8308 15.4075C18.6991 16.3842 18.4225 17.175 17.7991 17.7992C17.175 18.4225 16.3841 18.6992 15.4075 18.8308C14.4575 18.9583 13.245 18.9583 11.7133 18.9583H8.28663C6.75496 18.9583 5.54163 18.9583 4.59246 18.8308C3.61579 18.6992 2.82496 18.4225 2.20079 17.7992C1.57746 17.175 1.30079 16.3842 1.16913 15.4075C1.04163 14.4575 1.04163 13.245 1.04163 11.7133V8.28749C1.04163 6.75582 1.04163 5.54249 1.16913 4.59332C1.30079 3.61666 1.57746 2.82582 2.20079 2.20166C2.82579 1.57749 3.61829 1.30166 4.59913 1.16999C5.55246 1.04249 6.77163 1.04249 8.31163 1.04249H8.35829L8.47913 1.04166Z"
                                              fill="#0026B1"
                                            />
                                          </svg>
                                          Browse
                                        </span>
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                              {fileName && modalType !== "Excel" ? (
                                <div className="mt-2">
                                  <div className="pdf-preview">
                                    <iframe
                                      title="PDF Preview"
                                      src={`${Assets_URL}/${fileName}#toolbar=0&view=fitH`}
                                      width="100%"
                                      height="90vh"
                                      style={{ minHeight: "500px" }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                excelData && (
                                  <div className="pdf-preview spreadsheet-height mt-2">
                                    <Spreadsheet
                                      data={excelData}
                                      onChange={handleSpreadsheetChange}
                                    />
                                  </div>
                                )
                              )}
                            </>
                          ) : (
                            <Spinner
                              animation="border"
                              role="status"
                              className="center-spinner"
                            ></Spinner>
                          )}
                        </div>
                      </>
                    ) : modalType === "Url" ? (
                      <>
                        <div
                          className="col-md-12"
                          style={{ backgroundColor: "white" }}
                        >
                          <div className="box mt-2" style={{ height: "70px" }}>
                            <div
                              className="link-input-container"
                              style={{ width: "95%" }}
                            >
                              {/* Left arrow outside the input field */}
                              <span className="link-input-arrow">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                                    fill="#181818"
                                  />
                                  <path
                                    d="M5.5605 12L11.781 18.219C11.9218 18.3598 12.0009 18.5508 12.0009 18.75C12.0009 18.9491 11.9218 19.1401 11.781 19.281C11.6402 19.4218 11.4492 19.5009 11.25 19.5009C11.0508 19.5009 10.8598 19.4218 10.719 19.281L3.969 12.531C3.89915 12.4613 3.84374 12.3785 3.80593 12.2874C3.76812 12.1963 3.74866 12.0986 3.74866 12C3.74866 11.9013 3.76812 11.8036 3.80593 11.7125C3.84374 11.6214 3.89915 11.5386 3.969 11.469L10.719 4.71897C10.8598 4.57814 11.0508 4.49902 11.25 4.49902C11.4492 4.49902 11.6402 4.57814 11.781 4.71897C11.9218 4.8598 12.0009 5.05081 12.0009 5.24997C12.0009 5.44913 11.9218 5.64014 11.781 5.78097L5.5605 12Z"
                                    fill="#181818"
                                  />
                                </svg>
                              </span>
                              <div className="link-input-inner-container">
                                <input
                                  type="text"
                                  placeholder="Enter YouTube URL"
                                  value={link}
                                  onChange={handleLinkUpload}
                                  name="url"
                                  className={error ? "error-border" : ""}
                                />
                                {link && (
                                  <span
                                    className="link-input-clear"
                                    onClick={clearLink}
                                  >
                                    ✕
                                  </span>
                                )}
                                {error && (
                                  <div
                                    style={{ color: "red", marginTop: "5px" }}
                                  >
                                    {t("YoutubeLink")}
                                  </div>
                                )}
                              </div>
                            </div>

                            {link && !error && (
                              <div className=" mt-5">
                                <iframe
                                  width="100%"
                                  height="600px"
                                  src={getYoutubeEmbedUrl(link)}
                                  title="Preview"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                ></iframe>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )  : modalType === "Google Meet Link" ? (
                      <>
                        <div
                          className="col-md-12"
                          style={{ backgroundColor: "white" }}
                        >
                          <div className="box mt-2" style={{ height: "70px" }}>
                            <div
                              className="link-input-container"
                              style={{ width: "95%" }}
                            >
                              {/* Left arrow outside the input field */}
                              <span className="link-input-arrow">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                                    fill="#181818"
                                  />
                                  <path
                                    d="M5.5605 12L11.781 18.219C11.9218 18.3598 12.0009 18.5508 12.0009 18.75C12.0009 18.9491 11.9218 19.1401 11.781 19.281C11.6402 19.4218 11.4492 19.5009 11.25 19.5009C11.0508 19.5009 10.8598 19.4218 10.719 19.281L3.969 12.531C3.89915 12.4613 3.84374 12.3785 3.80593 12.2874C3.76812 12.1963 3.74866 12.0986 3.74866 12C3.74866 11.9013 3.76812 11.8036 3.80593 11.7125C3.84374 11.6214 3.89915 11.5386 3.969 11.469L10.719 4.71897C10.8598 4.57814 11.0508 4.49902 11.25 4.49902C11.4492 4.49902 11.6402 4.57814 11.781 4.71897C11.9218 4.8598 12.0009 5.05081 12.0009 5.24997C12.0009 5.44913 11.9218 5.64014 11.781 5.78097L5.5605 12Z"
                                    fill="#181818"
                                  />
                                </svg>
                              </span>
                              <div className="link-input-inner-container">
                                <input
                                  type="text"
                                  value={link}
                                  onChange={handleLinkUpload}
                                  name="url"
                                  className={error ? "error-border" : ""}
                                />
                                {link && (
                                  <span
                                    className="link-input-clear"
                                    onClick={clearLink}
                                  >
                                    ✕
                                  </span>
                                )}
                                {error && (
                                  <div
                                    style={{ color: "red", marginTop: "5px" }}
                                  >
                                    {t("YoutubeLink")}
                                  </div>
                                )}
                              </div>
                            </div>

                            {link && !error && (
                              <div className=" mt-5">
                                <iframe
                                  width="100%"
                                  height="600px"
                                  src={link}
                                  title="Preview"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                ></iframe>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer-step step-chart-modal-footer align-items-center">
                {/* Checkbox for "Create another" */}
                {(id === null || fileUploaded) && (
                  <div className="form-check me-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="createAnotherCheckbox"
                      checked={createAnother}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="createAnotherCheckbox"
                    >
                      {t("meeting.formState.CreateAnother")}
                    </label>
                  </div>
                )}
                <button
                  className={`btn moment-btn`}
                  style={{ marginRight: "9px" }}
                  onClick={() => {
                    modalType === "Question"
                      ? validateQuestionStep()
                      : fromTodo
                        ? validateReprendeStep()
                        : validateStep();
                  }}
                  disabled={isValidate}
                >
                  {isValidate ? (
                    <Spinner
                      as="div"
                      variant="light"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      animation="border"
                      style={{
                        margin: "2px 12px",
                      }}
                    />
                  ) : isUpdate && !isDrop ? (
                    t("meeting.formState.Submit")
                  ) : (
                    t("meeting.formState.Create")
                  )}
                </button>
                {/* {isUpdate && !isDrop && (
                  <button
                    className={`btn moment-btn`}
                    style={{ marginRight: "9px", backgroundColor: "red" }}
                    onClick={deleteStep}
                    disabled={isDeleted}
                  >
                    {isDeleted ? (
                      <Spinner
                        as="div"
                        variant="light"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        animation="border"
                        style={{
                          margin: "2px 12px",
                        }}
                      />
                    ) : (
                      t("meeting.formState.Delete")
                    )}
                  </button>
                )} */}
                <button
                  className={`btn`}
                  style={{
                    outline: "none",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "10px",
                    fontSize: "16px",
                    color: "#0026b1",
                  }}
                  onClick={handleOpenDialog}
                >
                  {t("meeting.formState.Cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={showConfirmation}
        onHide={handleClose}
        dialogClassName="custom-modal-size custom-modal-border modal-dialog-centered"
      >
        <Modal.Header
          closeButton
          className="border-0"
          onClick={handleClose}
        ></Modal.Header>
        <Modal.Body className="text-center p-4">
          <h2 className="w-100 text-center fs-5 mb-4">
            {t("meeting.formState.step.Cancel Step")}
          </h2>
          <div className="d-flex justify-content-center gap-3 mb-3">
            <Button
              variant="outline-danger"
              className="px-4 py-2 confirmation-delete"
              onClick={cancelStep}
            >
              {t("meeting.formState.step.ConfirmBtn")}
            </Button>
            <Button
              variant="primary"
              className="px-4 py-2 confirmation-save"
              onClick={handleClose}
            >
              {t("meeting.formState.step.CancelBtn")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StepChartAction;
